import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Config } from 'datatables.net';
import { months } from 'moment';
import { setTime } from 'ngx-bootstrap/chronos/utils/date-setters';
import { Subject } from 'rxjs';
import { CustomDatePipe } from 'src/app/pipes/customdate.pipe';
import { ReportService } from 'src/app/services/report.service';
import { SocketService } from 'src/app/services/socket.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { adjustWith2DecimalsForUI } from "./../../common-functions";
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';


declare var $: any;

@Component({
  selector: 'app-invoice-data',
  templateUrl: './invoice-data.component.html',
  styleUrls: ['./invoice-data.component.css'],
  providers: [CustomDatePipe]
})

export class InvoiceDataComponent implements OnInit {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  


  invoiceStatus: any;
  dueDate: any;
  invoiceLink: any;
  invoiceLinkType: any;
  iscorporate: boolean = false;
  invoiceAmount: any;
  invoiceviewDetails: any = '';
  filterForm: FormGroup;
  invoiceStatusChangeValue: any
  filterOptions = [
    { label: 'Parent ID', value: 'parentId' },
    { label: 'Company Name', value: 'companyName' },
    { label: 'Stax Bill ID', value: 'staxBillId' },
    // Add more options as needed
  ];
  refundCreditDetails: any;
  invoiceNumber: any;
  customerId: any;
  otherpaymentMethodValue: any = false;
  fusbillCustomerIdDetails: any;
  invoiceDate: string;
  deleteInvoice: any;
  regenerateInvoice: any;
  cancelInvoice: any;
  refundInvoice: any;
  invoiceReason: any = '';
  invoiceActions: any = []
  invoiceStartDate = '';
  invoiceEndDate = ''
  generateInvoiceform: FormGroup = new FormGroup({
    filterIsMonthRangeGenerate: new FormControl(''),
    invoiceMonth: new FormControl(''),
    invoiceStatus: new FormControl(''),
    customerType: new FormControl(''),
    mailToCustomer: new FormControl(''),
    paymentMethod: new FormControl(''),
    generateCustomers: new FormControl(''),
    skipCustomers: new FormControl(''),
    skipMailCustomers: new FormControl(''),

  });
  // refundInvoiceForm: FormGroup = new FormGroup({

  //   reason: new FormControl(''),
  //   paymentMethod: new FormControl(''),
  //   OtherpaymentMethod: new FormControl(''),
  //   refundType: new FormControl(''),
  //   refundAmount: new FormControl(''),
  //   tax: new FormControl(''),
  //   refundAmountTotal: new FormControl(''),

  // });
  editInvoiceForm: FormGroup = new FormGroup({
    invoiceDate: new FormControl(''),
    dueDate: new FormControl(''),
    invoiceAmount: new FormControl(''),
    invoicestatus: new FormControl(''),
    reason: new FormControl(''),

  });

  refundInvoiceFormPayment: FormGroup = new FormGroup({

    reason: new FormControl(''),
    paymentMethod: new FormControl(''),
    OtherpaymentMethod: new FormControl(''),

  });
  refundInvoiceForm: FormArray;


  refundCancelInvoiceForm: FormGroup = new FormGroup({
    refundStatus: new FormControl(''),

  });

  deleteForm: FormGroup = new FormGroup({
    confirmationText: new FormControl(''),
  });

  invoiceStatusForm: FormGroup = new FormGroup({
    confirmationText: new FormControl(''),
  });
  regenerateForm: FormGroup = new FormGroup({
    confirmationText: new FormControl(''),
  });

  

  getInvoiceDetails: any = '';
  showrefundAmount: boolean = false;
  provinces: any = [];
  finalinvoiceres: any = [];
  pdfUrls: any[] = []
  invoiceAmountDetails: any;
  invoiceAmountPaidDetails: any;
  invoiceHSTTax: any;
  invoiceGSTTax: any;
  invoicePSTTax: any;
  invoiceQSTTax: any;
  invoicePSTCriticalTax: any;
  invoicePSTHealthTax: any
  filteredData: any[];
  specificInvoiceAmount: any;
  specificInvoiceAmountPaid: any;
  finalCustomerRes: any[] = []
  customerTypeRes: any[] = []
  historyDetails: any[] = []
  OverdueLTE_30: any;
  OverdueBTW_30_60: any;
  OverdueBTW_60_90: any;
  OverdueGT_90: any;
  overDueAmount: any = -1
  actionButtons: { condition: any; backgroundColor: string; icon: string; label: string; onClick: () => void; }[];
  InvoiceChangeMessage: any;
  finalCorpValue: any[] = [];
  refundMethods: any;
  searchValue:any='';



  constructor(
    private toastr: ToastrService,
    private http: HttpClient,
    private router: Router,
    private service: ReportService,
     private route: ActivatedRoute,
    private socket: SocketService, private cdRef: ChangeDetectorRef,
    private _CustomDatePipe: CustomDatePipe, private fb: FormBuilder
  ) {
    this.filterForm = this.fb.group({
      filters: this.fb.array([]),
    });

    this.addFilter(); // Initialize with one filter row
  }

  role: string;

  // configs
  dtOptions: Config = {
    pagingType: 'simple_numbers',
    processing: true,
    dom: 'lrtip', // Disable the built-in search box (use custom search)
    language: {
      searchPlaceholder: 'Search here...',
    },
    columnDefs: [
      {
        targets: [7],  // Index of the "Amount" column
        orderable: false
      }
    ],
  };
  dtTrigger: Subject<any> = new Subject<any>();
  dtTrigger1: Subject<any> = new Subject<any>();
  dtTrigger2: Subject<any> = new Subject<any>();
  dtTrigger3: Subject<any> = new Subject<any>();
  maxDateForPicker: Date;
  minDateForPicker: Date;

  dropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Deselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };
  dropdownSettings1 = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'shortName',
    selectAllText: 'Select All',
    unSelectAllText: 'Deselect All',
    itemsShowLimit: 4,
    allowSearchFilter: true,
  };
  dropdownSettings2 = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    idField: 'fusebillCustomerId',
    textField: 'displayText',
    selectAllText: 'Select All',
    unSelectAllText: 'Deselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };
  dropdownSettings3 = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    idField: 'value',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Deselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };

  // fill filters
  brokerid: any[] = [];
  invoiceValue: any[] = [];
  SpecialinvoiceValue: any[] = [];
  generateInvoiceIds: any[] = [];
  skipgenerateInvoiceIds: any[] = [];
  skipMailgenerateInvoiceIds: any[] = [];
  provinceNames: any[] = [];;
  reportTypes: any[] = [];
  invoiceMethods: any[] = [];
  refundPaymentMethods: any[] = [];
  refundPaymentMethods1: any[] = [];
  customerType: any[] = [];
  brokerType: any[] = [];
  InvoiceStatus: any[] = [];
  specialFilters: any[] = [];
  FilterValues: any[] = [];
  advisors: any[] = [];
  BrokersData: any[] = [];
  customerTypeValue1: any[] = [];

  // filter
  filterReportType = '';
  filterIsMonthRange = false;

  filterDateSelection = '';
  filterDateSelectionGenerate = '';
  filterAdvisors: any[] = [];
  paymentMethodValue: any = '';
  customerid: any = '';
  customerDetails: any[] = [];
  customerName: any = '';
  fusbillCustomerId: any = '';
  customerTypeValue: any = '';
  brokerTypeValue: any = '';
  invoiceTypeValue: any = ''
  specialInvoiceTypeValue: any = ''

  data = [];
  isViewReport = false;
  viewInVoices = false;
  inVoiceList: any;
  title = 'Report';
  pdfSrc: string | ArrayBuffer | null = null;

  tableHeaders: any;
  actions: string[] = [];
  paymentDetails: any[] = [];
  selectedAction: any = '';
  // reportRequests = [];

  // payment
  paymentMonth = '';
  paymentDate = new Date();
  paymentAmountPaid = 0;

  titleAdjustment = '';
  isEditAdjustment = false;
  historyAdjustment = [];
  formAdjustment = new FormGroup({
    reportTypeId: new FormControl(0),
    type: new FormControl('credit'),
    month: new FormControl(''),
    // impactedMonth: new FormControl(''),
    amount: new FormControl(''),
    description: new FormControl(''),
    // status: new FormControl(''),
    subId: new FormControl(0),
  });
  isDisabled: boolean = false;
  invoiceStatusChange: any;
  isAmountAscending: any = true;
  // refundInvoiceForm: FormGroup;
  ngOnInit(): void {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'View Invoices');
    },100)
    // $("#deleteConfirmationModal").modal('show');
    // $("#refundcancel-model").modal('show');





    this.generateInvoiceform = this.fb.group({
      filterIsMonthRangeGenerate: [false, [Validators.required]],
      invoiceMonth: ['', [Validators.required]],
      invoiceStatus: ['', [Validators.required]],
      customerType: ['', [Validators.required]],
      mailToCustomer: ['', [Validators.required]],
      paymentMethod: ['', [Validators.required]],
      generateCustomers: [''],
      skipCustomers: [''],
      skipMailCustomers: [''],
    });

    this.refundInvoiceForm = this.fb.array([]);
    // this.addRow(); // Add an initial row

    // this.refundInvoiceForm = this.fb.group({
    //   // plans: this.fb.array([]),
    //   reason: ['', [Validators.required]],
    //   paymentMethod: ['', [Validators.required]],
    //   OtherpaymentMethod: [''],
    //   refundType: ['', [Validators.required]],
    //   refundAmount: ['', [Validators.required]],
    //   tax: ['', [Validators.required]],
    //   refundAmountTotal: ['', [Validators.required]],

    // });
    this.refundInvoiceFormPayment = this.fb.group({
      //   // plans: this.fb.array([]),
      reason: ['', [Validators.required]],
      paymentMethod: ['', [Validators.required]],
      OtherpaymentMethod: [''],

    });



    this.editInvoiceForm = this.fb.group({
      invoiceDate: ['', [Validators.required]],
      dueDate: ['', [Validators.required]],
      invoiceAmount: ['', [Validators.required]],
      invoicestatus: ['', [Validators.required]],
      reason: ['', [Validators.required]],

    });
    this.refundCancelInvoiceForm = this.fb.group({
      refundStatus: ['', [Validators.required]],

    });
    this.deleteForm = this.fb.group({
      confirmationText: ['', [Validators.required]],
    });
    this.invoiceStatusForm = this.fb.group({
      confirmationText: ['', [Validators.required]],
    });

    this.regenerateForm = this.fb.group({
      confirmationText: ['', [Validators.required]],
    });


    // this.invoiceMethods=[{"id":1,"name":"All"},{"id":2,"name":"Credit Card"},{"id":3,"name":"PAD"},{"id":4,"name":"EFT"}]
    this.FilterValues = [{ "id": 1, "name": "All" }, { "id": 2, "name": "Change From Previous Month" }, { "id": 3, "name": "Overdue <= 30 Days" }, { "id": 4, "name": "Overdue >30 <= 60 Days" }, { "id": 5, "name": "Overdue > 60 Days" }, { "id": 6, "name": "Corporations" }, { "id": 7, "name": "GIG" }, { "id": 8, "name": "Associations" }]
    this.role = sessionStorage.getItem('role');

    // this.getReportTypes();
    this.getBrokers()

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    this.maxDateForPicker = new Date(currentYear, currentMonth + 1);
    // this.minDateForPicker = new Date('2024-07-31'); // july 2024
    this.minDateForPicker = new Date('2024-07-01'); // june 2024 ==>for testing

    // this.socket.listen('privateNotification').subscribe((data: any) => {
    //   // setTimeout(() => {
    //   //   this.applyFilters();
    //   // }, 1000);
    // });

    this.invoiceData()
      this.invoiceNumber = this.route.snapshot.paramMap.get('invoiceNumber')!;
    console.log('Invoice number:', this.invoiceNumber);
  }

  addRow() {
    const row = this.fb.group({
      //   // plans: this.fb.array([]),
      refundType: [''],
      refundAmount: [''],
      tax: [''],
      refundAmountTotal: [''],
    });
    this.refundInvoiceForm.push(row);
  }
  get filters(): FormArray {
    return this.filterForm.get('filters') as FormArray;
  }
  get invoice() {
    return this.generateInvoiceform.controls;
  }
  get editinvoice() {
    return this.editInvoiceForm.controls;
  }

  onRefundinvoiceChange2(event: any) {
    console.log(event.target.value)
    console.log(this.refundInvoiceForm.value)


    if (event.target.value == 'FULL') {
      console.log("1")
      this.refundInvoiceForm.get('refundAmount')?.clearValidators();
      this.refundInvoiceForm.get('refundAmount')?.reset();
      this.refundInvoiceForm.get('refundAmount')?.updateValueAndValidity();
      this.showrefundAmount = false



    } else {
      console.log("2")
      this.refundInvoiceForm.get('refundAmount')?.setValidators(Validators.required);
      this.refundInvoiceForm.get('refundAmount')?.reset();
      this.refundInvoiceForm.get('refundAmount')?.updateValueAndValidity();
      this.showrefundAmount = true

    }

  }
  addFilter() {
    const filterGroup = this.fb.group({
      type: [''], // Default selected type (can be changed)
      value: [''], // Default value
    });
    this.filters.push(filterGroup);
  }

  removeFilter(index: number) {
    this.filters.removeAt(index);
  }

  clearFilters() {
    while (this.filters.length) {
      this.filters.removeAt(0);
    }
    this.addFilter(); // Add an initial empty filter row
  }

  search() {
    if (this.filterForm.valid) {
      const filterData = this.filterForm.value.filters;
      console.log('Search data:', filterData);
      // Perform search action using filterData
    }
  }
  public invoiceData() {

    var accessToken = sessionStorage.getItem('accessToken');
    var GetInvoiceData = `/api/ap/invoices/configurations`;


    this.http.get(environment.apiUrl + GetInvoiceData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {

      console.log(response)

      this.invoiceMethods = response.data.paymentMethods.sort(
        (a: any, b: any) => (a.name > b.name ? 1 : -1)
      );
      let credit = {
        "name": "Credit",
        "key": "Credit",
        "value": "Credit"
      }

      this.refundPaymentMethods = this.invoiceMethods.filter(method => method.value !== "All");
      this.refundPaymentMethods.push(credit)

      this.refundMethods = response.data.refundMethods
      this.refundPaymentMethods1 = [
        {
          "name": "Original Payment Method",
          "key": "original",
          "value": "Original_Payment_Method"
        },
        {
          "name": "Credit to account",
          "key": "Credit",
          "value": "Credit"
        },

        {
          "name": "Other",
          "key": "Other",
          "value": "Other"
        }
      ]
      // this.customerType = response.data.customerTypes.sort(
      //   (a: any, b: any) => (a.name > b.name ? 1 : -1)
      // );
      this.customerType = response.data.customerTypes_v2.sort(
        (a: any, b: any) => (a.name > b.name ? 1 : -1)
      );
      this.brokerType = response.data.brokerTypes.sort(
        (a: any, b: any) => (a.name > b.name ? 1 : -1)
      );
      this.InvoiceStatus = response.data.invoiceStatus.sort(
        (a: any, b: any) => (a.name > b.name ? 1 : -1)
      );
      this.specialFilters = response.data.specialFilters.sort(
        (a: any, b: any) => (a.name > b.name ? 1 : -1)
      );
      this.provinces = response.data.provinces.sort(
        (a: any, b: any) => (a.name > b.name ? 1 : -1)
      );

    }), (error) => {
      // this.loader = false
      // Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
    this.dtTrigger1.unsubscribe();


  }
  onSearch(value): void {
    const table = $('#DataTables_Table_1').DataTable();
    table.search(value).draw();  // Apply search query to DataTable
    console.log(value)
    this.filteredData = [...this.inVoiceList]
    this.filteredData = this.inVoiceList.filter((item, index) =>
      item.type.toLowerCase().includes(value.toLowerCase()) || item.customer.firstName.toLowerCase().includes(value.toLowerCase()) || item.customer.lastName.toLowerCase().includes(value.toLowerCase()) ||
      index == value - 1 || item.invoiceNumber.includes(value) || item.customer.fusebillCustomerId.includes(value)
    );
    console.log(this.filteredData)
    // this.inVoiceList = this.filteredData
    this.pdfUrls = []

    var total = 0
    var amountPaid = 0
    var gsttax = 0
    var hsttax = 0
    var psttax = 0
    var pstHealthinsurancetax = 0
    var pstCriticalinsurancetax = 0
    var OVERDUE_LTE_30 = 0
    var OVERDUE_BTW_30_60 = 0
    var OVERDUE_BTW_60_90 = 0
    var OVERDUE_GT_90 = 0
    let hasOverdue = false
    for (let i = 0; i < this.filteredData.length; i++) {
      let obj: any = {
        "invoiceNumber": this.filteredData[i].invoiceNumber,
        "link": this.filteredData[i].link,
        "invoiceDate": this.filteredData[i].invoiceDate,
        "status": this.filteredData[i].status,
        "Name": this.filteredData[i].customer.firstName + " " + this.filteredData[i].customer.lastName,
        "Range": this.invoiceStartDate + " to " + this.invoiceEndDate

      }
      // if (this.filteredData[i].link) {
      this.pdfUrls.push(obj)
      total += parseFloat(this.filteredData[i].invoiceAmount);
      if (this.filteredData[i].amountPaid != null) {
        amountPaid += parseFloat(this.filteredData[i].amountPaid);
      }

      if (this.filteredData[i]?.taxInformation?.overall_taxes && this.filteredData[i].taxInformation?.overall_taxes?.PST) {

        psttax += parseFloat(this.filteredData[i].taxInformation?.overall_taxes?.PST)
      }
      if (this.filteredData[i]?.taxInformation?.overall_taxes && this.filteredData[i].taxInformation?.overall_taxes?.HST) {
        hsttax += parseFloat(this.filteredData[i].taxInformation?.overall_taxes.HST)
      }
      if (this.filteredData[i]?.taxInformation?.overall_taxes && this.filteredData[i].taxInformation?.overall_taxes?.GST) {

        gsttax += parseFloat(this.filteredData[i].taxInformation?.overall_taxes.GST)
      }
      if (this.filteredData[i]?.taxInformation?.overall_taxes && this.filteredData[i].taxInformation?.overall_taxes?.QST) {
        gsttax += parseFloat(this.filteredData[i].taxInformation?.overall_taxes.QST)
      }
      if (
        this.filteredData[i]?.taxInformation?.overall_taxes &&
        'PST on Health Insurance' in this.filteredData[i].taxInformation.overall_taxes
      ) {
        pstHealthinsurancetax += parseFloat(this.filteredData[i].taxInformation.overall_taxes['PST on Health Insurance']);
      }

      if (
        this.filteredData[i]?.taxInformation?.overall_taxes &&
        'PST on Health Insurance' in this.filteredData[i].taxInformation.overall_taxes
      ) {
        pstCriticalinsurancetax += parseFloat(this.filteredData[i].taxInformation.overall_taxes['PST on Critical Illness']);
      }

      // }
      if (this.filteredData[i]?.overDueDays && this.filteredData[i].overDueDays > 0) {
       hasOverdue = this.filteredData.some(item => item?.overDueDays > 0);

        if (this.filteredData[i].overDueDays < 30) {
          OVERDUE_LTE_30 += parseFloat(this.filteredData[i].invoiceAmount)
        }
        if (this.filteredData[i].overDueDays > 30 && this.filteredData[i].overDueDays <= 60) {
          OVERDUE_BTW_30_60 += parseFloat(this.filteredData[i].invoiceAmount)
        }
        if (this.filteredData[i].overDueDays > 60 && this.filteredData[i].overDueDays <= 90) {
          OVERDUE_BTW_60_90 += parseFloat(this.filteredData[i].invoiceAmount)
        }
        if (this.filteredData[i].overDueDays > 90) {
          OVERDUE_GT_90 += parseFloat(this.filteredData[i].invoiceAmount)
        }
      }


    }
    if (!hasOverdue) {
      this.overDueAmount = 0;
    }
    // this.pdfUrls["range"] = invoiceStartDate + "-" + invoiceEndDate
    this.invoiceHSTTax = hsttax.toFixed(2)
    this.invoiceGSTTax = gsttax.toFixed(2)
    this.invoicePSTTax = psttax.toFixed(2)
    this.OverdueLTE_30 = OVERDUE_LTE_30.toFixed(2)
    this.OverdueBTW_30_60 = OVERDUE_BTW_30_60.toFixed(2)
    this.OverdueBTW_60_90 = OVERDUE_BTW_60_90.toFixed(2)
    this.OverdueGT_90 = OVERDUE_GT_90.toFixed(2)
    this.invoiceAmountDetails = total.toFixed(2)
    this.invoiceAmountPaidDetails = amountPaid.toFixed(2)

    this.invoicePSTHealthTax = pstHealthinsurancetax.toFixed(2)
    this.invoicePSTCriticalTax = pstCriticalinsurancetax.toFixed(2)
  }
  applySearch(value: string) {

    console.log(value)
    this.filteredData = [...this.inVoiceList]
    this.filteredData = this.inVoiceList.filter(item =>
      item.customer.firstName.toLowerCase().includes(value.toLowerCase()) || item.customer.lastName.toLowerCase().includes(value.toLowerCase()) ||
      item.invoiceNumber.toString().includes(value) || item.customer.fusebillCustomerId.toString().includes(value)
    );
    console.log(this.filteredData)
    this.inVoiceList = this.filteredData
    this.pdfUrls = []

    var total = 0
    var amountPaid = 0
    var gsttax = 0
    var hsttax = 0
    var psttax = 0
    var pstHealthinsurancetax = 0
    var pstCriticalinsurancetax = 0
    var OVERDUE_LTE_30 = 0
    var OVERDUE_BTW_30_60 = 0
    var OVERDUE_BTW_60_90 = 0
    var OVERDUE_GT_90 = 0
    let hasOverdue = false
    for (let i = 0; i < this.inVoiceList.length; i++) {
      let obj: any = {
        "invoiceNumber": this.inVoiceList[i].invoiceNumber,
        "link": this.inVoiceList[i].link,
        "invoiceDate": this.inVoiceList[i].invoiceDate,
        "status": this.inVoiceList[i].status,
        "Name": this.inVoiceList[i].customer.firstName + " " + this.inVoiceList[i].customer.lastName,
        // "Range": invoiceStartDate + " to " + invoiceEndDate

      }
      // if (this.inVoiceList[i].link) {
      this.pdfUrls.push(obj)
      total += parseFloat(this.inVoiceList[i].invoiceAmount);
      if (this.inVoiceList[i].amountPaid != null) {
        amountPaid += parseFloat(this.inVoiceList[i].amountPaid);
      }
      if (this.inVoiceList[i]?.taxInformation?.overall_taxes && this.inVoiceList[i].taxInformation?.overall_taxes?.PST) {

        psttax += parseFloat(this.inVoiceList[i].taxInformation?.overall_taxes?.PST)
      }
      if (this.inVoiceList[i]?.taxInformation?.overall_taxes && this.inVoiceList[i].taxInformation?.overall_taxes?.HST) {
        hsttax += parseFloat(this.inVoiceList[i].taxInformation?.overall_taxes.HST)
      }
      if (this.inVoiceList[i]?.taxInformation?.overall_taxes && this.inVoiceList[i].taxInformation?.overall_taxes?.GST) {

        gsttax += parseFloat(this.inVoiceList[i].taxInformation?.overall_taxes.GST)
      }
      if (this.inVoiceList[i]?.taxInformation?.overall_taxes && this.inVoiceList[i].taxInformation?.overall_taxes?.QST) {
        gsttax += parseFloat(this.inVoiceList[i].taxInformation?.overall_taxes.QST)
      }
      if (
        this.inVoiceList[i]?.taxInformation?.overall_taxes &&
        'PST on Health Insurance' in this.inVoiceList[i].taxInformation.overall_taxes
      ) {
        pstHealthinsurancetax += parseFloat(this.inVoiceList[i].taxInformation.overall_taxes['PST on Health Insurance']);
      }

      if (
        this.inVoiceList[i]?.taxInformation?.overall_taxes &&
        'PST on Health Insurance' in this.inVoiceList[i].taxInformation.overall_taxes
      ) {
        pstCriticalinsurancetax += parseFloat(this.inVoiceList[i].taxInformation.overall_taxes['PST on Critical Illness']);
      }

      // }

      if (this.inVoiceList[i]?.overDueDays && this.inVoiceList[i].overDueDays > 0) {
        // hasOverdue = true
        hasOverdue = this.inVoiceList.some(item => item?.overDueDays > 0);

        if (this.inVoiceList[i].overDueDays < 30) {
          OVERDUE_LTE_30 += parseFloat(this.inVoiceList[i].invoiceAmount)
        }
        if (this.inVoiceList[i].overDueDays > 30 && this.inVoiceList[i].overDueDays <= 60) {
          OVERDUE_BTW_30_60 += parseFloat(this.inVoiceList[i].invoiceAmount)
        }
        if (this.inVoiceList[i].overDueDays > 60 && this.inVoiceList[i].overDueDays <= 90) {
          OVERDUE_BTW_60_90 += parseFloat(this.inVoiceList[i].invoiceAmount)
        }
        if (this.inVoiceList[i].overDueDays > 90) {
          OVERDUE_GT_90 += parseFloat(this.inVoiceList[i].invoiceAmount)
        }
      }


    }
    if (!hasOverdue) {
      this.overDueAmount = 0;
    }
    // this.pdfUrls["range"] = invoiceStartDate + "-" + invoiceEndDate
    this.invoiceAmountDetails = total.toFixed(2)
    this.invoiceAmountPaidDetails = amountPaid.toFixed(2)
    this.invoiceHSTTax = hsttax.toFixed(2)
    this.invoiceGSTTax = gsttax.toFixed(2)
    this.invoicePSTTax = psttax.toFixed(2)
    this.OverdueLTE_30 = OVERDUE_LTE_30.toFixed(2)
    this.OverdueBTW_30_60 = OVERDUE_BTW_30_60.toFixed(2)
    this.OverdueBTW_60_90 = OVERDUE_BTW_60_90.toFixed(2)
    this.OverdueGT_90 = OVERDUE_GT_90.toFixed(2)

    this.invoicePSTHealthTax = pstHealthinsurancetax.toFixed(2)
    this.invoicePSTCriticalTax = pstCriticalinsurancetax.toFixed(2)

    // const table = $(this.dtElement.dtInstance);
    // table.DataTable().search(value).draw();
    // console.log(table)
  }

  exportTableToExcel() {
    // Assuming `table` is a DataTables instance
    // const table = $('#DataTables_Table_1').DataTable();

    // // Retrieve filtered data (visible rows after filtering)
    // const filteredData = table.rows({ search: 'applied' }).data().toArray();

    // // Get table headers
    // const headers = $('#DataTables_Table_1 thead tr th')
    //   .map(function () {
    //     return $(this).text().trim();
    //   })
    //   .get();
    // const columnsToIgnore = ['Actions']; // Replace with your headers' names

    // // Find the indices of headers to ignore
    // const indicesToIgnore = headers
    //   .map((header, index) => (columnsToIgnore.includes(header) ? index : -1))
    //   .filter(index => index !== -1);

    // // Filter headers to exclude ignored columns
    // const filteredHeaders = headers.filter((_, index) => !indicesToIgnore.includes(index));

    // // Filter data rows to exclude columns matching the ignored indices
    // const filteredRows = filteredData.map((row: any) =>
    //   row.filter((_, index: number) => !indicesToIgnore.includes(index))
    // );
    // const processedData = Array.from(filteredRows).map(row => {
    //   const cells = $(row).find('td').map(function () {
    //     const $cell = $(this);

    //     // Check if the cell contains a `<select>` element
    //     if ($cell.find('select').length > 0) {
    //       // Extract the selected value
    //       return $cell.find('select').val() || 'Select'; // Default to 'Select' if no value is chosen
    //     }

    //     return $cell.text().trim(); // For regular cells, just return the text content
    //   }).get();

    //   return cells; // Return the processed row
    // });
    // // Combine headers and filtered rows
    // const excelData = [filteredHeaders, ...processedData];

    // // Convert data to an Excel worksheet
    // const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(excelData);

    // // Create a workbook and append the worksheet
    // const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, 'FilteredData');

    // // Write workbook to a file
    // const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // // Save the file
    // const data: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    // saveAs(data, `Invoice(${this.pdfUrls[0].Range}).xlsx`);

    const table = $('#DataTables_Table_1').DataTable();

    // Retrieve filtered data (visible rows after filtering)
    const filteredData = table.rows({ search: 'applied' }).nodes(); // Get row DOM nodes

    // Get table headers
    const headers = $('#DataTables_Table_1 thead tr th')
      .map(function () {
        return $(this).text().trim();
      })
      .get();

    // Specify header columns to ignore
    const columnsToIgnore = ['#', 'Actions']; // Replace with your headers' names

    // Find the indices of headers to ignore
    const indicesToIgnore = headers
      .map((header, index) => (columnsToIgnore.includes(header) ? index : -1))
      .filter(index => index !== -1);

    // Filter headers to exclude ignored columns
    const filteredHeaders = headers.filter((_, index) => !indicesToIgnore.includes(index));

    // Process rows to extract actual values, including selected values from `<select>`
    const limitedHeaders = filteredHeaders.slice(0, 6);
    const processedRows = Array.from(filteredData).map(row => {
      const $row = $(row);
      if ($row.hasClass('ignoreTable')) return null;
      const cells = $(row).find('td').map(function (index) {
        // Skip ignored columns
        if (indicesToIgnore.includes(index)) return null;

        if (index >= 7) return null;
        const $cell = $(this);

        // Check if the cell contains a `<select>` element
        if ($cell.find('select').length > 0) {
          return $cell.find('select').val() || 'Select'; // Extract the selected value
        }

        return $cell.text().trim(); // Extract plain text for other cells
      }).get();

      // Exclude null cells (ignored columns)
      return cells.filter(cell => cell !== null);
    });
    const filteredRows = processedRows.filter(row => row !== null);

    // Combine headers and processed rows
    const excelData = [limitedHeaders, ...filteredRows];

    // Convert data to an Excel worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(excelData);

    // Create a workbook and append the worksheet
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `Invoice(${this.pdfUrls[0].Range})`);

    // Write workbook to a file
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Save the file
    const data: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(data, `Invoice(${this.pdfUrls[0].Range}).xlsx`);


  }



  // exportToExcel(){
  //   this.exportDataToExcel(this.inVoiceList, 'Invoice');
  // }
  applyFilters() {

    // return false

    console.log(typeof this.paymentMethodValue)
    let start = '';
    let end = '';
    this.invoiceStartDate = '';
    this.invoiceEndDate = ''
    if (this.filterIsMonthRange) {
      const startDate = new Date(this.filterDateSelection[0]);
      const startYear = startDate.getFullYear();
      const startMonth = String(startDate.getMonth() + 1).padStart(2, '0');
      const day = String(startDate.getDate()).padStart(2, '0');

      const endDate = new Date(this.filterDateSelection[1]);
      const endYear = endDate.getFullYear();
      const endMonth = endDate.getMonth();
      const lastDayOfMonth = new Date(endYear, endMonth + 1, 0);

      this.invoiceStartDate = `${startYear}-${startMonth}`
      this.invoiceEndDate = `${lastDayOfMonth.getFullYear()}-${String(lastDayOfMonth.getMonth() + 1).padStart(2, '0')}`


      start = `${startYear}-${startMonth}-${day}`;
      end = `${lastDayOfMonth.getFullYear()}-${String(lastDayOfMonth.getMonth() + 1).padStart(2, '0')}-${String(lastDayOfMonth.getDate()).padStart(2, '0')}`;
    } else {
      if (!this.filterDateSelection) {
        return;
      }
      const date = new Date(this.filterDateSelection);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      const endYear = date.getFullYear();
      const endMonth = date.getMonth(); // Months are zero-indexed

      // Set the date to the first day of the next month, then subtract one day
      const lastDayOfMonth = new Date(endYear, endMonth + 1, 0); // Day 0 gives the last day of the previous month

      // Format the date as yyyy-mm-dd
      this.invoiceStartDate = `${year}-${month}`
      this.invoiceEndDate = `${lastDayOfMonth.getFullYear()}-${String(lastDayOfMonth.getMonth() + 1).padStart(2, '0')}`
      start = `${year}-${month}-${day}`;
      end = `${lastDayOfMonth.getFullYear()}-${String(lastDayOfMonth.getMonth() + 1).padStart(2, '0')}-${String(lastDayOfMonth.getDate()).padStart(2, '0')}`;
    }
    this.viewInVoices = true;
    this.searchValue = '';



    var accessToken = sessionStorage.getItem('accessToken');
    var GetInvoiceData = `/api/ap/invoices/list`;

    // let array=[{ "searchterm": "invoiceDate","searchvalue": { "from": start,"to": end } }]
    let array = []

    if (this.paymentMethodValue) {
      array.push({ "searchterm": "paymentType", "searchvalue": this.paymentMethodValue })
    }

    if (this.customerTypeValue) {
      array.push({ "searchterm": "customerType", "searchvalue": this.customerTypeValue })
    }

    if (this.brokerTypeValue) {
      array.push({ "searchterm": "brokerType", "searchvalue": this.brokerTypeValue })
    }

    if (this.brokerid && this.brokerid.length > 0) {
      // array.push({ "searchterm": "brokerId","searchvalue": String(this.brokerid) })
      array.push({ "searchterm": "brokerId", "searchvalue": JSON.stringify(this.brokerid) });
    }
    if (this.provinceNames && this.provinceNames.length > 0) {
      // array.push({ "searchterm": "brokerId","searchvalue": String(this.brokerid) })
      array.push({ "searchterm": "province", "searchvalue": JSON.stringify(this.provinceNames) });
    }

    if (this.invoiceTypeValue) {
      array.push({ "searchterm": "status", "searchvalue": this.invoiceTypeValue })
    }

    if (this.specialInvoiceTypeValue) {
      array.push({ "searchterm": "specialFilterOverdue", "searchvalue": this.specialInvoiceTypeValue })
    }

    if (this.customerid) {
      array.push({ "searchterm": "customerId", "searchvalue": this.customerid })
    }


    if (this.customerDetails && this.customerDetails.length > 0) {
      // array.push({ "searchterm": "brokerId","searchvalue": String(this.brokerid) })
      array.push({ "searchterm": "customerIds", "searchvalue": JSON.stringify(this.customerDetails) });
    }

    if (this.fusbillCustomerId) {
      array.push({ "searchterm": "fusebillCustomerId", "searchvalue": this.fusbillCustomerId })
    }

    if (this.customerName) {
      array.push({ "searchterm": "customerName", "searchvalue": this.customerName })
    }

    array.push({ "searchterm": "invoiceDate", "searchvalue": { "from": start, "to": end } })

    let obj = {
      "whereObj": array,
      "limit": 0,
      "skip": 0
    }

    this.http.post(environment.apiUrl + GetInvoiceData, obj, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe(
      (response: any) => {
        this.inVoiceList = response.data
        this.pdfUrls = []

        var total = 0
        var amountPaid = 0
        var gsttax = 0
        var hsttax = 0
        var psttax = 0
        var qsttax = 0
        var pstHealthinsurancetax = 0
        var pstCriticalinsurancetax = 0
        var OVERDUE_LTE_30 = 0
        var OVERDUE_BTW_30_60 = 0
        var OVERDUE_BTW_60_90 = 0
        var OVERDUE_GT_90 = 0
        let hasOverdue = false;
        for (let i = 0; i < this.inVoiceList.length; i++) {
          let obj: any = {
            "invoiceNumber": this.inVoiceList[i].invoiceNumber,
            "link": this.inVoiceList[i].link,
            "invoiceDate": this.inVoiceList[i].invoiceDate,
            "status": this.inVoiceList[i].status,
            "Name": this.inVoiceList[i].customer.firstName + " " + this.inVoiceList[i].customer.lastName,
            "Range": this.invoiceStartDate + " to " + this.invoiceEndDate

          }
          // if (this.inVoiceList[i].link) {
          this.pdfUrls.push(obj)
          total += parseFloat(this.inVoiceList[i].invoiceAmount);
          if (this.inVoiceList[i]?.taxInformation?.overall_taxes && this.inVoiceList[i].taxInformation?.overall_taxes?.PST) {

            psttax += parseFloat(this.inVoiceList[i].taxInformation?.overall_taxes?.PST)
          }
          if (this.inVoiceList[i]?.taxInformation?.overall_taxes && this.inVoiceList[i].taxInformation?.overall_taxes?.HST) {
            hsttax += parseFloat(this.inVoiceList[i].taxInformation?.overall_taxes.HST)
          }
          if (this.inVoiceList[i]?.taxInformation?.overall_taxes && this.inVoiceList[i].taxInformation?.overall_taxes?.GST) {

            gsttax += parseFloat(this.inVoiceList[i].taxInformation?.overall_taxes.GST)
          }
          if (this.inVoiceList[i]?.taxInformation?.overall_taxes && this.inVoiceList[i].taxInformation?.overall_taxes?.QST) {
            gsttax += parseFloat(this.inVoiceList[i].taxInformation?.overall_taxes.QST)
          }
          if (
            this.inVoiceList[i]?.taxInformation?.overall_taxes &&
            'PST on Health Insurance' in this.inVoiceList[i].taxInformation.overall_taxes
          ) {
            pstHealthinsurancetax += parseFloat(this.inVoiceList[i].taxInformation.overall_taxes['PST on Health Insurance']);
          }

          if (
            this.inVoiceList[i]?.taxInformation?.overall_taxes &&
            'PST on Health Insurance' in this.inVoiceList[i].taxInformation.overall_taxes
          ) {
            pstCriticalinsurancetax += parseFloat(this.inVoiceList[i].taxInformation.overall_taxes['PST on Critical Illness']);
          }

          if (this.inVoiceList[i].amountPaid != null) {
            amountPaid += parseFloat(this.inVoiceList[i].amountPaid);
          }
          // }
          console.log(this.inVoiceList[i].overDueDays)
          if (this.inVoiceList[i]?.overDueDays && this.inVoiceList[i].overDueDays > 0) {

            hasOverdue = this.inVoiceList.some(item => item?.overDueDays > 0);
            if (this.inVoiceList[i].overDueDays < 30) {
              OVERDUE_LTE_30 += parseFloat(this.inVoiceList[i].invoiceAmount)
            }
            if (this.inVoiceList[i].overDueDays > 30 && this.inVoiceList[i].overDueDays <= 60) {
              OVERDUE_BTW_30_60 += parseFloat(this.inVoiceList[i].invoiceAmount)
            }
            if (this.inVoiceList[i].overDueDays > 60 && this.inVoiceList[i].overDueDays <= 90) {
              OVERDUE_BTW_60_90 += parseFloat(this.inVoiceList[i].invoiceAmount)
            }
            if (this.inVoiceList[i].overDueDays > 90) {
              OVERDUE_GT_90 += parseFloat(this.inVoiceList[i].invoiceAmount)
              console.log(OVERDUE_GT_90)
            }
          }


        }
        if (!hasOverdue) {
          this.overDueAmount = 0;
        }
        // invoiceHSTTax: any;
        // invoiceGSTTax: any;
        // invoicePSTTax: any;
        // this.pdfUrls["range"] = invoiceStartDate + "-" + invoiceEndDate
        this.invoiceAmountDetails = total.toFixed(2)
        this.invoiceAmountPaidDetails = amountPaid.toFixed(2)
        this.invoiceHSTTax = hsttax.toFixed(2)
        this.invoiceGSTTax = gsttax.toFixed(2)
        this.invoicePSTTax = psttax.toFixed(2)
        this.invoiceQSTTax = qsttax.toFixed(2)
        this.invoicePSTHealthTax = pstHealthinsurancetax.toFixed(2)
        this.invoicePSTCriticalTax = pstCriticalinsurancetax.toFixed(2)

        console.log(OVERDUE_GT_90)

        this.OverdueLTE_30 = OVERDUE_LTE_30.toFixed(2)
        this.OverdueBTW_30_60 = OVERDUE_BTW_30_60.toFixed(2)
        this.OverdueBTW_60_90 = OVERDUE_BTW_60_90.toFixed(2)
        this.OverdueGT_90 = OVERDUE_GT_90.toFixed(2)
        $('#DataTables_Table_1').dataTable().fnDestroy();
        this.dtTrigger.next(null);


        // next: (res: any) => {
        //   $('#DataTables_Table_1').dataTable().fnDestroy();
        //   this.dtTrigger.next(null);

        //   this.inVoiceList = res.data
        // },
        // error: (error) => {
        //   console.log(error);
        // },

      });

  }
  getTaxColor(tax: string): string {
    // console.log(tax)
    switch (tax) {
      case 'HST':
        return 'blue'; // Color for HST
      case 'PST_HEALTH_INSURANCE':
        return 'green'; // Color for PST
      case 'GST':
        return 'orange'; // Color for GST
      case 'QST':
        return 'purple'; // Color for QST
      case 'PST':
        return 'orange'; // Color for QST
      case 'PST_CRITICAL_INSURANCE':
        return 'orangered'; // Color for QST
      default:
        return 'black'; // Default color
    }
  }

  DownloadInvoice(invoice: any) {
    this.http.get(invoice, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = `${this.getInvoiceDetails.invoiceNumber}` + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: "Error", text: error.error.error.message })
      }
    );

  }
  async downloadAllAsZip() {

    const invoiceNumber = [];

    Swal.fire({
      title: "Alert",
      text: "Download the invoices?",
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Download",
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.isDisabled = true
        const zip = new JSZip();

        this.toastr.info(`Invoice download started for ${this.pdfUrls.length} records...', 'Please wait`);
        let pdflinks: any = [];

        for (let i = 0; i < this.pdfUrls.length; i++) {
          if (this.pdfUrls[i].link) {
            pdflinks.push(this.pdfUrls[i].link)
          }
        }
        var accessToken = sessionStorage.getItem('accessToken');
        var GetInvoiceData = `/api/ap/invoices/download/multiple`;

        //  var requestOptions: any = {
        //       method: 'POST',

        //    body: pdflinks,

        //       redirect: 'follow',
        //       headers: { Authorization: 'Bearer ' + accessToken },
        //     };

        // fetch(environment.apiUrl + GetInvoiceData, requestOptions)
        //       .then((response) => response.text())
        //   .then((response: any) => {

        //     console.log(response)

        //       }).catch(err => {

        //       })
        var accessToken = sessionStorage.getItem('accessToken');
        var GetInvoiceData = `/api/ap/invoices/download/multiple`;
        this.http.post(environment.apiUrl + GetInvoiceData, pdflinks, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',

          },
          responseType: 'blob',
        }).subscribe(
          (response: any) => {

            console.log(response)
            let blob: Blob = new Blob([response], { type: 'application/zip' }); // response is your Blob from the server

            // Trigger the download with a filename
            saveAs(blob, `Invoice(${this.pdfUrls[0].Range}).zip`);
            this.isDisabled = false
            this.toastr.success(`Invoice download completed for ${this.pdfUrls.length} records!', '`);

            // for (const pdf of this.pdfUrls) {
            //   invoiceNumber.push(pdf.invoiceNumber)
            //   try {
            //     const response = await fetch(pdf.link);
            //     const blob = await response.blob();

            //     // Add the PDF to the zip file with a custom name using 'number'
            //     zip.file(`${pdf.Name}-(${pdf.status})-(${pdf.invoiceNumber})-(${this.formatInvoiceDate(pdf.invoiceDate)}).pdf`, blob);
            //   } catch (error) {
            //     console.error(`Failed to fetch PDF at ${pdf.link}:`, error);
            //   }
            // }

            // // Generate the zip file
            // zip.generateAsync({ type: 'blob' }).then((content) => {
            //   // Use FileSaver.js to save the zip file
            //   saveAs(content, `Invoice(${this.pdfUrls[0].Range}).zip`);
            //   this.toastr.success(`Invoice download completed for ${this.pdfUrls.length} records!', '`);

            // });

          },
        );


      }
    })




  }
  public formatInvoiceDate(invoiceDate: string): string {
    const date = new Date(invoiceDate); // Convert to Date object
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date format");
    }

    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Get month (0-based index, so +1)
    const year = date.getFullYear().toString().slice(-2); // Get last two digits of the year

    return `${month}-${year}`;
  }
  async mailtocustomers() {
    var accessToken = sessionStorage.getItem('accessToken');
    var GetInvoiceData = `/api/ap/invoices/notify`;
    const invoiceNumber = [];
    let message;
    if (this.pdfUrls.length == 1) {
      message = 'customer'
    }
    else {
      message = 'customers'
    }

    Swal.fire({
      title: "Alert",
      text: `Are you sure you want to send invoices to the ${message}?`,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Send",
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        for (let i = 0; i < this.pdfUrls.length; i++) {
          await invoiceNumber.push(this.pdfUrls[i].invoiceNumber)
        }
        this.http.post(environment.apiUrl + GetInvoiceData, invoiceNumber, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe({
          next: (res: any) => {
            this.toastr.success('Invoic sent to customers', 'Success')


          },
          error: (error) => {
            console.log(error);
          },
        });
      }
    })





  }
  viewInvoiceDetailspdf() {
    // alert("!")
    $('#viewInvoice-modal').modal('show');

  }


  viewInvoiceDetails(invoice: any) {
    // return false
    this.getInvoiceDetails = invoice
    let res = this.getSpecificInvoiceData(invoice)
    $('#viewInvoice-modal').modal('show');
    this.selectedAction = ''
    this.getInvoiceDetailsModel(invoice)
    // setTimeout(() => {
    //   this.invoiceLink = "https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/server/MemberInvoices/Invoice_13429894_2024-10-01_24-10-4205_DRAFT.pdf"

    // }, 1000);
  }
  editInvoiceDetails(invoice: any) {
    this.editInvoiceForm.reset()

    // alert("1")
    // return false

    this.getInvoiceDetails = invoice
    this.getSpecificInvoiceData(invoice)
    $('#editInvoice-modal').modal('show');

    console.log(this.getInvoiceDetails)

  }
  showInvoiceHistory(invoice: any) {
    // return false

    this.getInvoiceDetails = invoice
    this.getSpecificInvoiceData(invoice)
    var accessToken = sessionStorage.getItem('accessToken');
    var GetInvoiceHistory = `/api/ap/get-history/${invoice.invoiceNumber}`;

    this.http.get(environment.apiUrl + GetInvoiceHistory, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {
        console.log(res)

        this.historyDetails = res.data

        if (this.historyDetails.length > 1) {
          $('#DataTables_Table_2').dataTable().fnDestroy();
          this.dtTrigger1.next(null);
        }



      },
      error: (error) => {
        console.log(error);
      },
    });
    $('#historyInvoice-modal').modal('show');



  }

  onAmountInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;

    // Allow only numbers and up to 2 decimal places
    const regex = /^\d*\.?\d{0,2}$/;

    // Check the current value
    if (regex.test(inputElement.value) || inputElement.value === '') {
      this.invoiceAmount = inputElement.value;
    } else {
      // If invalid, revert to the previous value
      inputElement.value = this.invoiceAmount;
    }
  }

  objectKeys(obj: any): { key: string, value: any }[] {
    if (obj) {
      return Object.entries(obj).map(([key, value]) => ({ key, value }));
    } else {
      return [];
    }
  }
  getpaymentName(value: any) {

    if (value) {
      if (value !== 'NONE') {
        let paymentValue = this.invoiceMethods.filter(payment => payment.value == value)
        return paymentValue[0].name
      }
      else {
        return "NONE"
      }
    }

  }

  getInvoiceStatus(value: any) {

    if (value) {
      let status = this.InvoiceStatus.filter(payment => payment.value == value)
      return status[0].name
    }

  }
  getSpecificInvoiceData(invoice) {
    var accessToken = sessionStorage.getItem('accessToken');
    var GetInvoiceData = `/api/ap/invoices/no/${invoice.invoiceNumber}`;


    this.invoiceviewDetails = invoice

    this.http.get(environment.apiUrl + GetInvoiceData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {

        console.log(res)
        this.finalinvoiceres = res
        this.invoiceNumber = res.invoiceNumber
        this.customerId = res.customerId
        this.fusbillCustomerIdDetails = res.fusebillCustomerId
        this.invoiceDate = this._CustomDatePipe.transform(res.invoiceDate)
        this.invoiceStatus = res.status
        this.dueDate = this._CustomDatePipe.transform(res.dueDate)
        this.invoiceAmount = res.invoiceAmount
        this.deleteInvoice = res.delete;
        this.regenerateInvoice = res.regenerate;
        this.cancelInvoice = res.cancel;
        this.refundInvoice = res.refund;
        this.iscorporate = res.accountType == 'Company' ? true : false

        // const control = <FormArray>this.refundInvoiceForm.get('plans');
        if (this.finalinvoiceres.customerType != 'Corporate' && this.finalinvoiceres.accountType != 'Company') {

          this.finalinvoiceres.planInformation.forEach((plan, index) => {
            const row = this.fb.group({

              refundType: [''],
              refundAmount: [''],
              tax: [''],
              refundAmountTotal: [''],
            });
            this.refundInvoiceForm.push(row);
          });
        }
        else {
          this.getPlans()
          let finalValue = Object.entries(this.finalinvoiceres.planInformation).map(([key, details]) => ({ key, details }));
          console.log(Object.entries(this.finalinvoiceres.planInformation).map(([key, details]) => ({ key, details })))
          console.log(finalValue)
          finalValue.forEach((plan: any, index) => {
            console.log('Plan Key:', plan.key); // Logs the plan key (e.g., '43339')

            // Check if 'plans' and 'subscriptions' exist
            if (plan.details.plans && plan.details.plans.subscriptions) {
              plan.details.plans.subscriptions.forEach((subscription, subIndex) => {
                console.log('Subscription:', subscription); // Logs each subscription object

                // You can access subscription properties like this:
                console.log('Plan Name:', subscription.planName);
                console.log('Amount:', subscription.amount);
                console.log('Tax:', subscription.tax);

                const row = this.fb.group({
                  refundType: [''],
                  refundAmount: [''],
                  tax: [''],
                  refundAmountTotal: [''],
                });

                this.refundInvoiceForm.push(row); // Pushes the form group to the array
              });
            }
          });

          console.log(this.refundInvoiceForm)


          // let value= Object.entries(this.finalinvoiceres.planInformation).map(([key, details]) => ({ key, details }));

          // // console.log(plan.details.plans.subscriptions)
          // value.forEach((plan, index) => {

          //   console.log(plan)
          //   plan.details.plans.subscriptions.forEach((plan, index) => {
          //     console.log(plan.details.plans.subscriptions)
          //   const row = this.fb.group({

          //     refundType: [''],
          //     refundAmount: [''],
          //     tax: [''],
          //     refundAmountTotal: [''],
          //   });
          //     this.refundInvoiceForm.push(row);
          //   });

          // });
        }
        this.actionButtons = [
          {
            condition: this.refundInvoice,
            backgroundColor: 'green',
            icon: 'fa fa-undo',
            label: 'Refund',
            onClick: () => this.invoiceActionsStatus('refund'),
          },
          {
            condition: this.deleteInvoice,
            backgroundColor: 'red',
            icon: 'fa fa-trash',
            label: 'Delete',
            onClick: () => this.invoiceActionsStatus('delete'),
          },
          {
            condition: this.regenerateInvoice,
            backgroundColor: 'orange',
            icon: 'fa fa-refresh',
            label: 'Re-Generate',
            onClick: () => this.invoiceActionsStatus('regenerate'),
          },
        ];

        setTimeout(() => {
          // this.invoiceLink = "https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/server/MemberInvoices/Invoice_13429894_2024-10-01_24-10-4205_DRAFT.pdf"
          // this.invoiceLink = res.link
          const blob = new Blob([res.link], { type: 'application/pdf' });

          if (this.invoiceLinkType == 'https/link') {
            this.invoiceLink = this.invoiceLink;
          } else {
            // Create a URL for the Blob
            this.invoiceLink = URL.createObjectURL(blob);
          }
          console.log(this.invoiceLink)
        }, 1000);




        this.specificInvoiceAmount = parseFloat(res.invoiceAmount);
        if (res.amountPaid != null) {

          this.specificInvoiceAmountPaid = parseFloat(res.amountPaid);
        }
        else {

          this.specificInvoiceAmountPaid = 0
        }


        // this.pdfUrls["range"] = invoiceStartDate + "-" + invoiceEndDate
        this.specificInvoiceAmount = adjustWith2DecimalsForUI(this.specificInvoiceAmount)
        this.specificInvoiceAmountPaid = adjustWith2DecimalsForUI(this.specificInvoiceAmountPaid)


        // alert(this.specificInvoiceAmountPaid)
        // if (this.deleteInvoice) {
        //   this.invoiceActions.push(this.deleteInvoice)
        // }
        // if (this.regenerateInvoice) {
        //   this.invoiceActions.push(this.regenerateInvoice)
        // }
        // if (this.cancelInvoice) {
        //   this.invoiceActions.push(this.cancelInvoice)
        // }
        // if (this.refundInvoice) {
        //   this.invoiceActions.push(this.refundInvoice)
        // }
        // this.invoiceStatus = res.status
        // this.dueDate = this._CustomDatePipe.transform(res.dueDate)
        // // this.invoiceLink = res.link


        // this.invoiceAmount = res.invoiceAmount

        // console.log(this.invoiceLink)



        // $('#DataTables_Table_1').dataTable().fnDestroy();
        // this.dtTrigger.next(null);

        // this.inVoiceList = res.data
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
  getInvoiceDetailsModel(invoice) {
    var accessToken = sessionStorage.getItem('accessToken');
    var GetInvoiceData = `/api/ap/invoices/no/${invoice.invoiceNumber}/view/doc/false`;

    this.http.get(environment.apiUrl + GetInvoiceData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {

        console.log(res)


        setTimeout(() => {
          this.invoiceLinkType = res.linkType
          this.invoiceLink = res.link
        }, 1000);

      },
      error: (error) => {
        console.log(error);
      },
    });

  }
  selectedPlans: any[] = [];

  planCheckbox(item: any, event: any): void {
    if (event.target.checked) {
      // Add the selected item to the selectedPlans array
      this.selectedPlans.push(item);
    } else {
      // Remove the unselected item from the selectedPlans array
      this.selectedPlans = this.selectedPlans.filter(plan => plan !== item);
    }
    console.log('Selected Plans:', this.selectedPlans);
  }

  selectedItems: any[] = [];

  // Handle checkbox change and update the selected items
  updateItemData(item: any, event: any): void {
    item.selected = event.target.checked;

    if (item.selected) {
      // Add item to the selectedItems array
      this.selectedItems.push({ ...item });
      this.isCheckboxDisabledTotal(item)
      this.isCheckboxDisabledPartial(item)
    } else {
      // Remove item from the selectedItems array
      const index = this.selectedItems.findIndex(i => i.planName === item.planName);
      if (index !== -1) {
        this.selectedItems.splice(index, 1);
        this.isCheckboxDisabledTotal(item)
        this.isCheckboxDisabledPartial(item)
        item.refundType = null
      }
    }

    console.log('Selected items:', this.selectedItems);
  }

  // Handle refund amount input change and update the item data
  updateRefundAmount(item: any, event: any, index: any): void {



    const row = this.refundInvoiceForm.at(index); // Access the row FormGroup by index

    // console.log(item)
    console.log(row.value)
    console.log(row.get('refundType')?.value)


    // let taxRate = 0;

    const nonZeroValues = Object.entries(item.taxDetailsDB)
      .filter(([_, value]) => (value as number) > 0) // Assert the value as a number
      .reduce((result: any, [key, value]) => {
        result[key] = value; // Rebuild the object
        return result;
      }, {} as { [key: string]: number });

    // console.log(nonZeroValues);

    let taxValue = 0;
    if ('gst' in nonZeroValues) {
      taxValue = nonZeroValues.gstTaxRate; // Access the value of pst
    }
    if ('pst' in nonZeroValues) {
      taxValue = nonZeroValues.pstTaxRate; // Access the value of pst
    }
    if ('hst' in nonZeroValues) {
      taxValue = nonZeroValues.hstTaxRate; // Access the value of pst
    }
    const updatedAmount = event.target.value;
    item.refundAmount = updatedAmount;

    // Update the refund amount in the selectedItems array if item is selected
    // if (item.selected) {
    const selectedItem = this.selectedItems.find(i => i.planName === item.planName);
    console.log(selectedItem)
    if (selectedItem) {
      let creditTotal = 0
      let refundTotal = 0
      let finalTotal = 0
      if (this.refundCreditDetails.creditInformation.length > 0) {
        for (let i = 0; i < this.refundCreditDetails.creditInformation.length; i++) {
          creditTotal += parseFloat(this.refundCreditDetails.creditInformation[i].creditAmount);
        }
      }
      if (this.refundCreditDetails.refundInformation.length > 0) {
        for (let i = 0; i < this.refundCreditDetails.refundInformation.length; i++) {
          refundTotal += parseFloat(this.refundCreditDetails.refundInformation[i].refundAmount);
        }
      }
      console.log(creditTotal)
      console.log(refundTotal)
      finalTotal = creditTotal + refundTotal;

      console.log(finalTotal)

      if (row.get('refundType')?.value == 'PARTIAL') {
        if (finalTotal > 0) {
          let amountAfterRefund = item.price - finalTotal
          console.log(amountAfterRefund)
          if (item.refundAmount > amountAfterRefund) {
            this.toastr.warning('Refund amount not greater than the Amount paid')
            row.get('refundAmount')?.reset();
            row.get('tax')?.reset();
            row.get('refundAmountTotal')?.reset();

            let obj = {
              refundAmount: 0,
              tax: 0,
              refundAmountTotal: 0
            }

            selectedItem.changedDetails = obj

          }
          else {
            row.patchValue({
              refundAmount: updatedAmount,
              tax: ((updatedAmount * taxValue) / 100).toFixed(2),
              refundAmountTotal: ((+updatedAmount || 0) + (updatedAmount * taxValue / 100)).toFixed(2)
            });



            let obj = {
              refundAmount: updatedAmount || 0,
              tax: ((updatedAmount * taxValue) / 100).toFixed(2),
              refundAmountTotal: ((+updatedAmount || 0) + (updatedAmount * taxValue / 100)).toFixed(2)
            }

            selectedItem.changedDetails = obj
          }
        }
        else {
          if (item.price < item.refundAmount) {
            this.toastr.warning('Refund amount not greater than the Amount paid')
            // this.refundInvoiceForm.value.refundAmount?.reset()
            row.get('refundAmount')?.reset();
            row.get('tax')?.reset();
            row.get('refundAmountTotal')?.reset();

          }
          else {

            row.patchValue({
              refundAmount: updatedAmount,
              tax: ((updatedAmount * taxValue) / 100).toFixed(2),
              refundAmountTotal: ((+updatedAmount || 0) + (updatedAmount * taxValue / 100)).toFixed(2)
            });



            let obj = {
              refundAmount: +updatedAmount || 0,
              tax: ((updatedAmount * taxValue) / 100).toFixed(2),
              refundAmountTotal: ((+updatedAmount || 0) + (updatedAmount * taxValue / 100)).toFixed(2)
            }

            selectedItem.changedDetails = obj

          }
        }
      }
      else {

        if (item.price < item.refundAmount) {
          this.toastr.warning('Refund amount not greater than the Amount paid')
          // row.patchValue({
          //   refundAmount: item.price,
          //   tax: item.tax,
          //   refundAmountTotal: item.price + item.tax
          // });
          row.get('refundAmount')?.reset();
          row.get('tax')?.reset();
          row.get('refundAmountTotal')?.reset();

        }
        if (item.price > item.refundAmount) {
          this.toastr.warning('Refund amount not greater than the Amount paid')
          // row.patchValue({
          //   refundAmount: item.price,
          //   tax: item.tax,
          //   refundAmountTotal: item.price + item.tax
          // });
          row.get('refundAmount')?.reset();
          row.get('tax')?.reset();
          row.get('refundAmountTotal')?.reset();

        }


      }


    }
    // }

    // added by akhil -> to calculate tax
    // const enteredAmount = parseFloat(event.target.value) || 0;

    // // Get the tax from the item
    // const tax = item.tax;

    // // Calculate the base amount (refund amount - tax)
    // const baseAmount = enteredAmount - tax;

    // // Calculate the total amount (refund amount + tax)
    // const totalAmount = enteredAmount + tax;

    // // Update the form or model with the calculated values
    // item.refundAmount = enteredAmount;
    // item.baseAmount = baseAmount;
    // item.totalAmount = totalAmount;
    console.log('Updated refund amount for item:', item);
    console.log('Updated refund amount for item:', this.selectedItems);
  }
  isFormValid(): any {
    console.log(this.finalinvoiceres)
    if (this.finalinvoiceres.length > 0) {
      return this.finalinvoiceres.chargeGroups.every(item => {
        return !item.selected || (item.refundType && item.refundAmount);
      });
    }
  }
  // updateTaxAmount12(index: number) {

  //   const plan = this.refundInvoiceForm.get('plans')?.at(index) as FormGroup;
  //   const refundAmount = plan.get('refundAmount')?.value;

  //   // Debugging: Log the current plan values
  //   console.log('Current Plan:', plan.value);

  //   // Update tax value (example: setting tax to a fixed amount)
  //   const taxAmount = 10;  // Example: static tax value
  //   plan.patchValue({ tax: taxAmount });

  //   // If refundAmount exists, calculate the total and set refundAmountTotal
  //   if (refundAmount) {
  //     const totalAmount = refundAmount + taxAmount;  // Calculate total amount (refund + tax)
  //     plan.get('refundAmountTotal')?.setValue(totalAmount);  // Update refundAmountTotal
  //   }

  //   // Debugging: Log the updated plan values
  //   console.log('Updated Plan:', plan.value);

  //   // const plan = this.plans.at(index) as FormGroup;
  //   // const refundAmount = plan.get('tax')?.value;
  //   // console.log(plan)
  //   // plan.patchValue({ tax: 10 });
  //   // if (refundAmount) {
  //   //   const taxAmount = 10;  // Calculate the tax
  //   //   plan.get('tax')?.patchValue(15);  // Update the tax control value
  //   //   const totalAmount = refundAmount + taxAmount;  // Calculate total amount
  //   //   plan.get('refundAmountTotal')?.setValue(totalAmount);  // Update the total
  //   // }
  // }
  updateTaxAmount(index: number) {
    console.log(this.plans)
    const formGroup = this.plans.at(index);
    const plan = this.plans.at(index) as FormGroup; // Access the specific FormGroup

    const refundAmount = plan.get('refundAmount')?.value ?? 0; // Current Refund Amount

    const tax = refundAmount * 0.1; // Example Tax Calculation (10%)
    const total = refundAmount + tax; // Calculate Total


    // console.log(plan.get('refundAmount'))
    formGroup.patchValue({
      refundAmount: 10,  // Assuming 'amount' is the value for full refund
      tax: 10,              // Tax value associated with this plan
      refundAmountTotal: 20, // Calculate the total (if necessary)
    });

    // plan.controls["refundAmount"].setValue("A");
    // this.refundInvoiceForm.get('refundAmount').setValue(10)
    // Update the form controls
    // plan.setValue({
    //   tax: tax,
    //   refundAmountTotal: total,
    // });
    // plan.get('refundAmount')?.setValue('A');

    // console.log('Updated Plan:', plan); // For Debugging

    // this.plans[index].tax = 10
    // this.plans[index].refundAmount = 100
    // const plans = this.refundInvoiceForm.get('plans') as FormArray; // Ensure plans is a FormArray
    // const plan = this.plans.at(index) as FormGroup; // Access the specific FormGroup

    // console.group(plan)
    // plan.get('refundAmount')?.setValue(10);
    // plan.patchValue({ refundAmount: 10 });

    // if (!plan) {
    //   console.error(`Plan at index ${index} not found!`);
    //   return;
    // }

    // const refundAmount = plan.get('refundAmount')?.value;

    // // Set tax value
    // const taxAmount = 10; // Example static tax value
    // plan.patchValue({ tax: taxAmount });

    // // Calculate total refund amount
    // if (refundAmount) {
    //   const totalAmount = refundAmount + taxAmount;
    //   plan.patchValue({ refundAmountTotal: totalAmount }); // Update total
    // }
    // this.cdRef.detectChanges();
    console.log('Updated Plan:', plan.value);
  }

  checktaxValue(item) {
    const nonZeroValues = Object.entries(item.taxDetailsDB)
      .filter(([_, value]) => (value as number) > 0) // Assert the value as a number
      .reduce((result: any, [key, value]) => {
        result[key] = value; // Rebuild the object
        return result;
      }, {} as { [key: string]: number });

    // console.log(nonZeroValues);

    let taxValue;
    if ('pst' in nonZeroValues) {
      taxValue = nonZeroValues.pst; // Access the value of pst
    }
    if ('gst' in nonZeroValues) {
      taxValue = nonZeroValues.gst; // Access the value of pst
    }
    if ('hst' in nonZeroValues) {
      taxValue = nonZeroValues.hst; // Access the value of pst
    }

    // console.log(taxValue)
    return taxValue
    // return taxValue

  }
  getPlans1(): { key: string; details: any }[] {
    if (this.finalinvoiceres.planInformation) {
      return Object.entries(this.finalinvoiceres.planInformation).map(([key, details]) => ({ key, details }));
    }
  }
  getPlans() {
    // if (this.finalinvoiceres.planInformation) {
    //   return Object.entries(this.finalinvoiceres.planInformation).map(([key, details]) => ({ key, details }));
    // }


    let finalValue = Object.entries(this.finalinvoiceres.planInformation).map(([key, details]) => ({ key, details }));
    console.log(Object.entries(this.finalinvoiceres.planInformation).map(([key, details]) => ({ key, details })))
    console.log(finalValue)
    finalValue.forEach((plan: any, index) => {
      console.log('Plan Key:', plan.key); // Logs the plan key (e.g., '43339')

      // Check if 'plans' and 'subscriptions' exist
      if (plan.details.plans && plan.details.plans.subscriptions) {

        // if (plan.details.plans.subscriptions && plan.details.plans.subscriptions.length > 0) {
        //   this.finalCorpValue.push(plan.details)
        // }

        plan.details.plans.subscriptions.forEach((subscription, subIndex) => {
          let obj = {
            firstName: plan.details.firstName,
            lastName: plan.details.lastName,
            plans: subscription
          }
          this.finalCorpValue.push({
            ...subscription,       // Spread the properties of the subscription object
            firstName: plan.details.firstName,// Add firstName property from plan.details
            lastName: plan.details.lastName// Add firstName property from plan.details
          });
          // this.finalCorpValue.push(...subscription, 'firstName': plan.details.firstName)
          // this.finalCorpValue.push(obj)
        })
        // this.finalCorpValue =  plan.details.plans.subscriptions
      }
    });

    console.log(this.finalCorpValue)
  }
  onRefundinvoiceChange(item: any, event: any, index: any) {
    // this.isCheckboxDisabledInput(item)
    // item.refundType = event.target.value
    this.isCheckboxDisabled(item)
    console.log(this.refundInvoiceForm)
    const row = this.refundInvoiceForm.at(index); // Access the row FormGroup by index
    const nonZeroValues = Object.entries(item.taxDetailsDB)
      .filter(([_, value]) => (value as number) > 0) // Assert the value as a number
      .reduce((result: any, [key, value]) => {
        result[key] = value; // Rebuild the object
        return result;
      }, {} as { [key: string]: number });

    // console.log(nonZeroValues);

    let taxValue = 0;
    if ('pst' in nonZeroValues) {
      taxValue = nonZeroValues.pst; // Access the value of pst
    }
    if ('gst' in nonZeroValues) {
      taxValue = nonZeroValues.gst; // Access the value of pst
    }
    if ('hst' in nonZeroValues) {
      taxValue = nonZeroValues.hst; // Access the value of pst
    }

    if (item.selected) {
      const selectedItem = this.selectedItems.find(i => i.planName === item.planName);
      if (selectedItem) {
        selectedItem.refundType = event.target.value;

        if (event.target.value == 'FULL') {
          // console.log(item.price)
          // console.log(taxValue)

          console.log(row)

          row.patchValue({
            refundAmount: item.price,
            tax: taxValue,
            refundAmountTotal: (Number(item.price) + Number(taxValue)).toFixed(2)
          });

          let obj = {
            refundAmount: item.price,
            tax: taxValue,
            refundAmountTotal: (Number(item.price) + Number(taxValue)).toFixed(2)
          }

          selectedItem.changedDetails = obj



        } else {
          row.get('refundAmount').reset()
          row.get('tax').reset()
          row.get('refundAmountTotal').reset()
          let obj = {
            refundAmount: 0,
            tax: 0,
            refundAmountTotal: 0
          }

          selectedItem.changedDetails = obj
        }
      }
    }


    // this.updatePlanValue(index, 'refundType', event.target.value);
    // this.updatePlanValue(index, 'refundAmount', 10);
    // this.updatePlanValue(index, 'refundAmountTotal', 15);
    // this.updateTaxAmount(index)




  }
  onRefundinvoiceChange1(item: any, event: any, index: any,index1:any) {
    // this.isCheckboxDisabledInput(item)
    // item.refundType = event.target.value

    console.log(index1)
    console.log(index)
    this.isCheckboxDisabled(item)
    console.log(this.refundInvoiceForm)
    const row = this.refundInvoiceForm.at(index); // Access the row FormGroup by index
    const nonZeroValues = Object.entries(item.taxDetailsDB)
      .filter(([_, value]) => (value as number) > 0) // Assert the value as a number
      .reduce((result: any, [key, value]) => {
        result[key] = value; // Rebuild the object
        return result;
      }, {} as { [key: string]: number });

    // console.log(nonZeroValues);

    let taxValue = 0;
    if ('pst' in nonZeroValues) {
      taxValue = nonZeroValues.pst; // Access the value of pst
    }
    if ('gst' in nonZeroValues) {
      taxValue = nonZeroValues.gst; // Access the value of pst
    }
    if ('hst' in nonZeroValues) {
      taxValue = nonZeroValues.hst; // Access the value of pst
    }

    if (item.selected) {
      const selectedItem = this.selectedItems.find(i => i.planName === item.planName && i.firstName === item.firstName && i.lastName === item.lastName);
      if (selectedItem) {
        selectedItem.refundType = event.target.value;

        if (event.target.value == 'FULL') {
          // console.log(item.price)
          // console.log(taxValue)

          // console.log(this.finalCorpValue[index1])
          // this.finalCorpValue[index1].plans.subscriptions[index] = {
          //   ...this.finalCorpValue[index1].plans.subscriptions[index],
          //   reValue: item.price,
          // };
          // console.log(this.finalCorpValue)
          row.patchValue({
            refundAmount: item.price,
            tax: taxValue,
            refundAmountTotal: (Number(item.price) + Number(taxValue)).toFixed(2)
          });

          let obj = {
            refundAmount: item.price,
            tax: taxValue,
            refundAmountTotal: (Number(item.price) + Number(taxValue)).toFixed(2)
          }

          selectedItem.changedDetails = obj



        } else {
          row.get('refundAmount').reset()
          row.get('tax').reset()
          row.get('refundAmountTotal').reset()
          let obj = {
            refundAmount: 0,
            tax: 0,
            refundAmountTotal: 0
          }

          selectedItem.changedDetails = obj
        }
      }
    }


    // this.updatePlanValue(index, 'refundType', event.target.value);
    // this.updatePlanValue(index, 'refundAmount', 10);
    // this.updatePlanValue(index, 'refundAmountTotal', 15);
    // this.updateTaxAmount(index)




  }
  get plans(): FormArray {
    return this.refundInvoiceForm.get('plans') as FormArray;
  }
  get rows() {
    return this.refundInvoiceForm.controls; // This will return the FormGroups in the FormArray
  }
  updatePlanValue(index: number, field: string, value: any) {
    const plan = this.plans.at(index) as FormGroup;
    plan.get(field)?.setValue(value);
  }
  refundinvoiceAmount() {
    console.log(this.selectedItems)
    console.log(this.refundInvoiceForm.value);
    if (this.refundInvoiceForm.invalid) {
      this.refundInvoiceForm.markAllAsTouched();
      const invalid: any = [];
      const controls: any = this.refundInvoiceForm.controls;
      //this.consoleMessage(controls)







      // childrenDetails: this.formBuilder.array([this.initChildDetails()]),
      // childrenDetails:  new FormControl(''),

      for (let name in controls) {
        if (controls[name].invalid) {
          invalid.push(name)
        }
      }
      console.log(invalid)
    }

    if (this.refundInvoiceFormPayment.invalid) {
      this.refundInvoiceFormPayment.markAllAsTouched();
      const invalid: any = [];
      const controls: any = this.refundInvoiceFormPayment.controls;
      //this.consoleMessage(controls)







      // childrenDetails: this.formBuilder.array([this.initChildDetails()]),
      // childrenDetails:  new FormControl(''),

      for (let name in controls) {
        if (controls[name].invalid) {
          invalid.push(name)
        }
      }
      console.log(invalid)
    }

    console.log('Submitting selected items:', this.selectedItems);
    // this.refundInvoiceForm.value.paymentMethod
    var accessToken = sessionStorage.getItem('accessToken');
    var generateInvoiceData = `/api/ap/invoices/no/${this.getInvoiceDetails.invoiceNumber}/customer/${this.customerId}/refundAndCredits`;

    let creditCheck;
    let paymentMethod;
    let invoicesArray = []
    if (this.refundInvoiceFormPayment.value.paymentMethod == 'Credit') {
      creditCheck = true
      paymentMethod = ''
    }
    if (this.refundInvoiceFormPayment.value.paymentMethod == 'Original_Payment_Method') {
      creditCheck = false
      paymentMethod = this.finalinvoiceres.paymentMethod
    }
    if (this.refundInvoiceFormPayment.value.paymentMethod == 'Other') {
      creditCheck = false
      paymentMethod = this.refundInvoiceFormPayment.value.OtherpaymentMethod || ''
    }





    this.selectedItems.forEach((element: any) => {

      let obj = {
        "plan": {
          name: element.planName, //telemedicne kixcare
          subscriptionId: element.subscriptionId + "",
          price: element.price,
          refundPrice: element?.changedDetails?.refundAmount ?? 0,
          taxSubscriptionId: element.taxSubscriptionId,
          tax: element?.tax ?? 0,
          refundTax: element?.changedDetails?.tax ?? 0,
        },
        "refundDetails": {
          refundDate: new Date(),
          paymentMethod: paymentMethod,
          "admin": {
            id: 1,
            name: sessionStorage.getItem('loginname')
          },

        },


        subscriptionId: element.subscriptionId + "",
        isTax: false,
        refundType: element?.changedDetails?.refundType || 'PARTIAL',
        refundAmount: element?.changedDetails?.refundAmount ?? 0,
        // refundAmount: element?.refundAmount (this.refundInvoiceForm.value.refundAmount == '' || this.refundInvoiceForm.value.refundAmount == null) ? 0 : parseFloat(this.refundInvoiceForm.value.refundAmount),


      }


      let obj2 = {
        "plan": {
          name: element.planName, //Tax HST
          subscriptionId: element.subscriptionId + "",
          price: element.price,
          refundPrice: element?.changedDetails?.refundAmount ?? 0,
          taxSubscriptionId: element.taxSubscriptionId,
          tax: element?.tax ?? 0,
          refundTax: element?.changedDetails?.tax ?? 0
        },
        "refundDetails": {
          refundDate: moment().format("YYYY-MM-DD"),
          paymentMethod: paymentMethod,
          "admin": {
            id: 1,
            name: sessionStorage.getItem('loginname')
          },

        },

        isTax: true,
        subscriptionId: element.taxSubscriptionId + "",
        refundType: element?.changedDetails?.refundType || 'PARTIAL',
        refundAmount: element?.changedDetails?.tax ?? 0,
        // refundAmount: element?.refundAmount (this.refundInvoiceForm.value.refundAmount == '' || this.refundInvoiceForm.value.refundAmount == null) ? 0 : parseFloat(this.refundInvoiceForm.value.refundAmount),


      }
      invoicesArray.push(obj)
      if (element.taxSubscriptionId) {
        invoicesArray.push(obj2)
      }


    })

    let obj = {
      details: invoicesArray,
      invoiceType: this.getInvoiceDetails.type,
      reason: this.refundInvoiceFormPayment.value.reason,
      refundAsCredit: creditCheck,
      refundType: "PARTIAL"

    }

    console.log(obj)

    Swal.fire({
      title: "Info",
      text: "Are you sure you want to proceed with the refund (Note: this process is irreversible)",
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Proceed",
    }).then((result) => {
      if (result.isConfirmed) {
        this.http.post(environment.apiUrl + generateInvoiceData, obj, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe({
          next: (res: any) => {

            if (res.status == 200) {
              this.selectedItems = []
              this.refundInvoiceForm.reset()
              this.selectedAction = ''
              $("#refundInvoiceDetails-modal").modal('hide');
              $("#editInvoice-modal").modal('hide');

              Swal.fire({ title: 'Info', text: res.message })


            } else {

              Swal.fire({ title: 'Info', text: res.message })


            }


          },
          error: (error) => {
            console.log(error);
          },
        });
      }
    })



  }
  getInvoiceDetailsModel1(invoice) {
    var accessToken = sessionStorage.getItem('accessToken');
    var GetInvoiceData = `/api/ap/invoices/no/${invoice.invoiceNumber}/view/doc/false`;

    this.http.get(environment.apiUrl + GetInvoiceData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {
        let obj = { "link": res.link }


        this.pdfUrls.push(obj)


      },
      error: (error) => {
        console.log(error);
      },
    });

  }

  checkinvoicerefundAmount() {
    let refundamount = this.refundInvoiceForm.value.refundAmount;
    // this.specificInvoiceAmountPaid = 0
    console.log(this.specificInvoiceAmountPaid)
    if (this.specificInvoiceAmountPaid == null) {
      this.specificInvoiceAmountPaid = 0
    }
    var creditTotal = 0
    var refundTotal = 0
    var finalTotal = 0
    if (this.refundCreditDetails.creditInformation.length > 0) {
      for (let i = 0; i < this.refundCreditDetails.creditInformation.length; i++) {
        creditTotal += parseFloat(this.refundCreditDetails.creditInformation[i].creditAmount);
      }
    }
    if (this.refundCreditDetails.refundInformation.length > 0) {
      for (let i = 0; i < this.refundCreditDetails.refundInformation.length; i++) {
        refundTotal += parseFloat(this.refundCreditDetails.refundInformation[i].refundAmount);
      }
    }
    finalTotal = creditTotal + refundTotal;
    if (finalTotal > 0) {
      let amountAfterRefund = this.specificInvoiceAmountPaid - finalTotal
      console.log(amountAfterRefund)
      if (refundamount > amountAfterRefund) {
        this.toastr.warning('Refund amount not greater than the Amount paid')
        // this.refundInvoiceForm.value.refundAmount?.reset()
        this.refundInvoiceForm.get('refundAmount')?.reset();

      }
    }
    else {
      if (refundamount > this.specificInvoiceAmountPaid) {
        this.toastr.warning('Refund amount not greater than the Amount paid')
        // this.refundInvoiceForm.value.refundAmount?.reset()
        this.refundInvoiceForm.get('refundAmount')?.reset();

      }
    }



  }

  confirmDeletion() {
    var accessToken = sessionStorage.getItem('accessToken');

    var DeleteInvoiceData = `/api/ap//delete-invoices/${this.getInvoiceDetails.id}`;

    let obj = {
      "reason": this.deleteForm.value.confirmationText,
      "invoiceNumber": this.getInvoiceDetails.invoiceNumber,
      "invoiceType": this.getInvoiceDetails.invoiceType ?? this.getInvoiceDetails.type,
    }

    this.http.post(environment.apiUrl + DeleteInvoiceData, obj, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {
        $('#viewInvoice-modal').modal('hide');
        $('#deleteConfirmationModal').modal('hide');

        this.applyFilters()
        Swal.fire({ title: 'Info', text: 'The invoice has been deleted successfully.' })

      },
      error: (error) => {
        console.log(error);
      },
    });



  }

  confirmRegenerate() {
    var accessToken = sessionStorage.getItem('accessToken');
    // $('#viewInvoice-modal').modal('hide');


    const date = new Date(this.getInvoiceDetails.invoiceDate);

    // Extract month and year
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
    const year = date.getFullYear();

    // Format as MM-YYYY
    const formattedDate = `${month}-${year}`;
    var generateInvoiceData = `/api/ap/invoices/customer/generateInvoiceIGBMS/${formattedDate}/${this.getInvoiceDetails.status}`;

    // let obj: any =
    // {
    //   "ids": [this.getInvoiceDetails.customerId],  // ---? list of customer ids to generate invoice for --> get from customer selection --> if all, then empty array
    //   "skipIds": [],  // ---? list of customer ids to skip the invoice generation--> get from customer selection --> if nothing to skip, then empty array
    //   "skipMails": [], // ---? list of customer ids to generate the invoice but not trigger any mail--> get from customer selection --> if no customer to skip mail, then empty array
    //   "reason": this.regenerateForm.value.confirmationText,
    //   "invoiceNumber": this.getInvoiceDetails.invoiceNumber
    // }


    let obj: any =
    {
      "customerId": this.getInvoiceDetails.customerId.toString(),
      "reason": this.regenerateForm.value.confirmationText,
      "regenerate": true,
      "invoiceId": this.getInvoiceDetails.id.toString(),
      "void": false
    }

    this.http.post(environment.apiUrl + generateInvoiceData, obj, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {
        if (res.status == 200) {
          $('#viewInvoice-modal').modal('hide');
          $('#regenerateConfirmationModal').modal('hide');
          this.applyFilters()
          Swal.fire({ title: 'Info', text: 'The invoice has been regenerated successfully.' })
        }
        else {

          Swal.fire({ title: 'Info', text: res.message })
        }


      },
      error: (error) => {
        console.log(error);
      },
    });



  }

  invoiceActionsStatus(event) {
    console.log(event)

    if (event == "delete") {

      var accessToken = sessionStorage.getItem('accessToken');

      // $('#viewInvoice-modal').modal('hide');

      $('#deleteConfirmationModal').modal('show');
      this.deleteForm.reset()

      // Swal.fire({
      //   title: 'Deleting this invoice will remove it from the system and it will no longer appear.',
      //   input: 'textarea', // Use 'textarea' for multiline input
      //   inputPlaceholder: 'Please type reference',
      //   showCancelButton: true,
      //   confirmButtonText: 'Confirm',
      //   cancelButtonText: 'Cancel',

      //   inputValidator: (value) => {
      //     if (!value || value.trim() === '') {
      //       return 'You need to enter the reference!';
      //     }
      //     this.invoiceReason = value
      //     return null; // Return null if input is valid
      //   },
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     // Swal.fire('Submitted!', `Your comments: ${result.value}`, 'success');
      //     let obj = {
      //       "reason": this.invoiceReason,
      //       "invoiceNumber": this.getInvoiceDetails.invoiceNumber
      //     }

      //     this.http.post(environment.apiUrl + DeleteInvoiceData, obj, {
      //       headers: {
      //         Authorization: 'Bearer ' + accessToken,
      //         'Content-Type': 'application/json',
      //       }
      //     }).subscribe({
      //       next: (res: any) => {
      //         $('#viewInvoice-modal').modal('hide');

      //         this.applyFilters()
      //         Swal.fire({ title: 'Info', text: 'The invoice has been deleted successfully.' })

      //       },
      //       error: (error) => {
      //         console.log(error);
      //       },
      //     });
      //   }
      //   else {

      //     this.selectedAction = ''
      //   }
      //   // else if (result.dismiss === Swal.DismissReason.cancel) {
      //   //   Swal.fire('Cancelled', 'Your input was discarded.', 'error');
      //   // }
      // });

      // Swal.fire({
      //   title: "Alert",
      //   text: "Are you sure you want to delete this invoice?",
      //   showDenyButton: false,
      //   showCancelButton: true,
      //   cancelButtonText: "Cancel",
      //   confirmButtonText: "Proceed",
      // }).then((result) => {
      //   /* Read more about isConfirmed, isDenied below */
      //   if (result.isConfirmed) {

      //     this.http.delete(environment.apiUrl + DeleteInvoiceData, {
      //       headers: {
      //         Authorization: 'Bearer ' + accessToken,
      //         'Content-Type': 'application/json',
      //       }
      //     }).subscribe({
      //       next: (res: any) => {
      //         $('#editInvoice-modal').modal('hide');
      //         // Swal.fire({ title: "Info", text: res.message });
      //         this.applyFilters()
      //         // if (res.status == 200) {
      //         //   $('#editInvoice-modal').modal('hide');
      //         //   Swal.fire({ title: "Info", text: res.message });


      //         // }
      //       },
      //       error: (error) => {
      //         console.log(error);
      //       },
      //     });
      //   }
      // })



    }
    if (event == "refund") {
      this.refundInvoiceForm.reset()
      // this.refundInvoiceForm.clear()
      this.refundInvoiceFormPayment.reset()
      // this.refundInvoiceFormPayment.clear()

      // this.refundInvoiceForm.controls.forEach((control) => {
      //   control.reset(); // Resets the value of each control
      // });
      $('#viewInvoice-modal').modal('hide');
      $('#refundInvoiceDetails-modal').modal('show');
      // $("#refundInvoice-modal").modal('show');

      console.log('finalinvoiceres.planInformation', this.finalinvoiceres?.planInformation)

      this.getRefundDeatils(this.getInvoiceDetails.invoiceNumber)
      // Swal.fire({
      //   title: "Alert",
      //   text: "Are you sure you want to proceed with Refund?",
      //   showDenyButton: false,
      //   showCancelButton: true,
      //   cancelButtonText: "Cancel",
      //   confirmButtonText: "Proceed",
      // }).then((result) => {
      //   /* Read more about isConfirmed, isDenied below */
      //   if (result.isConfirmed) {
      //     $('#viewInvoice-modal').modal('hide');
      //     $("#refundInvoice-modal").modal('show');


      //     this.getRefundDeatils(this.getInvoiceDetails.invoiceNumber)

      //   }
      //   else {
      //     $('#viewInvoice-modal').modal('hide');
      //     this.selectedAction = ''
      //   }
      // })


    }
    if (event == "cancel") {

      var accessToken = sessionStorage.getItem('accessToken');
      var CancelInvoiceData = `/api/ap/invoice/no/${this.getInvoiceDetails.invoiceNumber}/ cancel`;


      Swal.fire({
        title: "Alert",
        text: "Are you sure you want to cancel this invoice?",
        showDenyButton: false,
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "Proceed",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          $('#viewInvoice-modal').modal('hide');
          $("#refundcancel-model").modal('show')
          this.refundCancelInvoiceForm.reset()

        }
        else {
          $('#viewInvoice-modal').modal('hide');
          this.selectedAction = ''
        }
      })



    }
    if (event == "regenerate") {

      $('#regenerateConfirmationModal').modal('show');
      this.regenerateForm.reset();



      // var accessToken = sessionStorage.getItem('accessToken');
      // // $('#viewInvoice-modal').modal('hide');


      // const date = new Date(this.getInvoiceDetails.invoiceDate);

      // // Extract month and year
      // const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
      // const year = date.getFullYear();

      // // Format as MM-YYYY
      // const formattedDate = `${month}-${year}`;
      // var generateInvoiceData = `/api/ap/invoices/customer/multiple/generateInvoiceIGBMS/${formattedDate}/${this.getInvoiceDetails.status}/false/All`;


      // Swal.fire({
      //   title: 'Are you sure you want to re-generate this invoice?',
      //   input: 'textarea', // Use 'textarea' for multiline input
      //   inputPlaceholder: 'Please type reason',
      //   showCancelButton: true,
      //   confirmButtonText: 'Confirm',
      //   cancelButtonText: 'Cancel',

      //   inputValidator: (value) => {
      //     if (!value || value.trim() === '') {
      //       return 'You need to enter the reason!';
      //     }
      //     this.invoiceReason = value
      //     return null; // Return null if input is valid
      //   },
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     // Swal.fire('Submitted!', `Your comments: ${result.value}`, 'success');
      //     let obj: any =
      //     {
      //       "ids": [this.getInvoiceDetails.customerId],  // ---? list of customer ids to generate invoice for --> get from customer selection --> if all, then empty array
      //       "skipIds": [],  // ---? list of customer ids to skip the invoice generation--> get from customer selection --> if nothing to skip, then empty array
      //       "skipMails": [], // ---? list of customer ids to generate the invoice but not trigger any mail--> get from customer selection --> if no customer to skip mail, then empty array
      //       "reason": this.invoiceReason,
      //       "invoiceNumber": this.getInvoiceDetails.invoiceNumber
      //     }

      //     this.http.post(environment.apiUrl + generateInvoiceData, obj, {
      //       headers: {
      //         Authorization: 'Bearer ' + accessToken,
      //         'Content-Type': 'application/json',
      //       }
      //     }).subscribe({
      //       next: (res: any) => {
      //         $('#viewInvoice-modal').modal('hide');
      //         this.applyFilters()
      //         Swal.fire({ title: 'Info', text: 'The invoice has been regenerated successfully.' })

      //       },
      //       error: (error) => {
      //         console.log(error);
      //       },
      //     });
      //   }
      //   else {

      //     this.selectedAction = ''
      //   }
      //   // else if (result.dismiss === Swal.DismissReason.cancel) {
      //   //   Swal.fire('Cancelled', 'Your input was discarded.', 'error');
      //   // }
      // });

      // Swal.fire({
      //   title: "Alert",
      //   text: "Are you sure you want to delete this invoice?",
      //   showDenyButton: false,
      //   showCancelButton: true,
      //   cancelButtonText: "Cancel",
      //   confirmButtonText: "Proceed",
      // }).then((result) => {
      //   /* Read more about isConfirmed, isDenied below */
      //   if (result.isConfirmed) {

      //     this.http.delete(environment.apiUrl + DeleteInvoiceData, {
      //       headers: {
      //         Authorization: 'Bearer ' + accessToken,
      //         'Content-Type': 'application/json',
      //       }
      //     }).subscribe({
      //       next: (res: any) => {
      //         $('#editInvoice-modal').modal('hide');
      //         // Swal.fire({ title: "Info", text: res.message });
      //         this.applyFilters()
      //         // if (res.status == 200) {
      //         //   $('#editInvoice-modal').modal('hide');
      //         //   Swal.fire({ title: "Info", text: res.message });


      //         // }
      //       },
      //       error: (error) => {
      //         console.log(error);
      //       },
      //     });
      //   }
      // })



    }

  }
  isCheckboxDisabled(item: any): boolean {
    // console.log(item)
    // Check if every charge satisfies the condition
    // return item.charges.every((charge: any) => item.creditedAmount == charge.amount);
    // return item.selected

    if (!item.selected) {
      // Clear the radio button value when checkbox is unchecked
      item.refundType = '';  // Or set it to an empty string based on your form model
    }
    return item.selected

  }
  // isCheckboxDisabledPlan(item: any): boolean {
  //   // console.log(item)
  //   // Check if every charge satisfies the condition
  //   // return item.charges.every((charge: any) => item.creditedAmount == charge.amount);
  //   // return item.selected



  // }
  isCheckboxDisabledInput(item: any): boolean {
    // console.log(item)
    // Check if every charge satisfies the condition
    // return item.charges.every((charge: any) => item.creditedAmount == charge.amount);
    return item.refundType == 'FULL' || item.refundType == 'PARTIAL'
  }

  isCheckboxDisabledTotal(item: any): boolean {
    // console.log(item)
    if (!item.selected) {
      // Clear the radio button value when checkbox is unchecked
      item.refundType = '';  // Or set it to an empty string based on your form model
    }


    if (this.refundCreditDetails) {
      const filteredArray = this.refundCreditDetails?.creditInformation.filter(item1 => item1.subscriptionId == item.subscriptionId);
      const filteredArray1 = this.refundCreditDetails?.refundInformation.filter(item1 => item1.subscriptionId == item.subscriptionId);



      const filteredArrayFinal = filteredArray.concat(filteredArray1)

      if (filteredArrayFinal.length > 0) {

        return false

      }
      else {
        return item.selected
      }
    }
    // Check if every charge satisfies the condition
    // return item.charges.every((charge: any) => item.creditedAmount >0);
    // return false
  }
  isCheckboxDisabledPartial(item: any): boolean {
    // console.log(item)
    if (!item.selected) {
      // Clear the radio button value when checkbox is unchecked
      item.refundType = '';  // Or set it to an empty string based on your form model
    }
    return item.selected
    // Check if every charge satisfies the condition
    // return item.charges.every((charge: any) => item.creditedAmount >0);
    // return false
  }


  getRefundDeatils(invoiceNumber) {
    var accessToken = sessionStorage.getItem('accessToken');
    var getInvoiceData = `/api/ap/invoices/no/${invoiceNumber}/customer/${this.customerId}/refundAndCredits`

    this.http.get(environment.apiUrl + getInvoiceData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {
        // if (res.status == 200) {
        console.log(res)
        this.refundCreditDetails = res.data

        const filteredArray = this.refundCreditDetails.creditInformation.filter(item1 =>
          this.finalinvoiceres.chargeGroups.some(item2 => item1.subscriptionId == item2.subscriptionId)
        );
        const filteredArray1 = this.refundCreditDetails.refundInformation.filter(item1 =>
          this.finalinvoiceres.chargeGroups.some(item2 => item1.subscriptionId == item2.subscriptionId)
        );


        const filteredArrayFinal = filteredArray.concat(filteredArray1)
        console.log(filteredArrayFinal);


        let totalAmount = 0;
        if (filteredArrayFinal.length > 0) {

          filteredArrayFinal.forEach((element: any) => {
            const selectedItem = this.finalinvoiceres.chargeGroups.find(i => i.subscriptionId == element.subscriptionId);

            console.log(selectedItem)
            if (selectedItem) {


              if (element.creditAmount) {
                totalAmount += element.creditAmount;
              }

              if (element.refundAmount) {
                totalAmount += element.refundAmount;
              }
              selectedItem.creditedAmount = totalAmount;
            }
          })


        }


        console.log(this.finalinvoiceres.chargeGroups)




        // }
      },
      error: (error) => {
        console.log(error);
      },
    });

  }
  generateInvoice() {
    $("#generateInvoice-modal").modal('show');



  }

  deleteInvoiceDetails(invoice: any) {
    var accessToken = sessionStorage.getItem('accessToken');
    var DeleteInvoiceData = `/api/ap/invoices/${invoice.id}`;

    Swal.fire({
      title: "Alert",
      text: "Are you sure you want to delete this invoice?",
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Proceed",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        this.http.delete(environment.apiUrl + DeleteInvoiceData, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe({
          next: (res: any) => {
            if (res.status == 200) {
              Swal.fire({ title: "Info", text: res.message });

            }
          },
          error: (error) => {
            console.log(error);
          },
        });
      }
    })


  }

  CancelInvoieStatus() {
    this.applyFilters()
  }
  confirmInvoiceStatus() {
    var accessToken = sessionStorage.getItem('accessToken');


    let obj = {
      newStatus: this.invoiceStatusChangeValue,
      oldStatus: this.invoiceStatusChange.status,
      invoiceType: this.invoiceStatusChange.type,
      reason: this.invoiceStatusForm.value.confirmationText,
      paymentType: null,
      paymentDetails: null,
      amountPaid: this.invoiceStatusChange.invoiceAmount
    }
    // var GetInvoiceData = `/api/ap/invoices/${invoice.id}/status/${status.target.value}/update`;
    var GetInvoiceData = `/api/ap/invoices/${this.invoiceStatusChange.invoiceNumber}/status/change`

    // let obj = {
    //   "reason": this.invoiceStatusForm.value.confirmationText,
    // }
    this.http.post(environment.apiUrl + GetInvoiceData, obj, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {

        if (res.status == 200) {
          $("#invoiceStatusConfirmationModal").modal('hide');
          this.applyFilters()


        }
        // $('#DataTables_Table_1').dataTable().fnDestroy();
        // this.dtTrigger.next(null);

        // this.inVoiceList = res.data
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  changeInvoiceStatus(event: Event, invoice: any) {

    const selectedValue = (event.target as HTMLSelectElement).value;
    this.invoiceStatusChangeValue = selectedValue
    this.invoiceStatusChange = invoice
    console.log(invoice)
    this.InvoiceChangeMessage = `Changing the invoice status from ${invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1).toLowerCase()} to ${selectedValue.charAt(0).toUpperCase() + selectedValue.slice(1).toLowerCase()}?`
    Swal.fire({
      title: "Info",
      text: `Change the invoice status from ${invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1).toLowerCase()} to ${selectedValue.charAt(0).toUpperCase() + selectedValue.slice(1).toLowerCase()}?`,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Proceed",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        $("#invoiceStatusConfirmationModal").modal('show');
        this.invoiceStatusForm.reset()

      }
      else {
        this.applyFilters()
      }
    })
  }
  resetFilters() {
    this.isViewReport = false;
    // this.filterReportType = '';
    this.filterReportType = '';
    this.invoiceAmountDetails = ''

    this.filterIsMonthRange = false;
    this.filterDateSelection = '';
    this.viewInVoices = false
    this.invoiceAmountDetails = false
    this.filterAdvisors = [];
    this.viewInVoices = false;
    // this.BrokersData = []
    this.invoiceTypeValue = ''
    this.paymentMethodValue = ''
    this.customerTypeValue = ''
    this.brokerTypeValue = ''
    this.invoiceTypeValue = ''
    this.filterReportType = ''
    this.customerid = ''
    this.fusbillCustomerId = ''
  }

  viewDetail(item) {
    if (this.filterReportType === '6') {
      this.paymentDetails = item.paymentDetails;
      $('#pad-report-modal').modal('show');
      this.dtTrigger2.next(null);
      $('#DataTables_Table_2').dataTable().fnDestroy();
    }
  }

  viewExcelReport() {
    this.router.navigate(['/report-detail']);
  }



  viewAdjustment(item) {
    console.log('adjustment', item);

    if (item.reportTypeId === 1) {
      this.titleAdjustment = item.pdfName;
    } else {
      this.titleAdjustment = item.xlsxName;
    }

    let subId = 0;
    switch (item.reportTypeId) {
      case 1:
        subId = item.advisorId;
        break;
      case 2:
        break;
      case 3:
        subId = item.partnerId;
        break;
      case 4:
        break;
      case 5:
        break;
      case 6:
        break;
      default:
    }

    this.service.getAdjustment(item.reportTypeId, item.date, subId).subscribe({
      next: (res: any) => {
        if (res) {
          this.isEditAdjustment = true;
          this.formAdjustment.patchValue({
            reportTypeId: item.reportTypeId,
            type: res.type,
            month: item.date,
            amount: res.amount,
            description: res.description,
            subId: subId,
          });
          this.historyAdjustment = res.history;
        } else {
          this.isEditAdjustment = false;
          this.formAdjustment.patchValue({
            reportTypeId: item.reportTypeId,
            month: item.date,
            subId: subId,
          });
        }

        $('#adjustment-modal').modal('show');
      },
      error: (error) => {
        console.log('getAdjustment', error);
      },
    });
  }

  viewFinalize(item) {
    this.paymentMonth = item.date;
    if (item.paymentDate) {
      this.paymentDate = new Date(item.paymentDate);
    } else {
      this.paymentDate = new Date();
    }
    this.paymentAmountPaid = item.amountPaid;
    $('#payment-modal').modal('show');
  }



  // on change events
  onPaymentTypeChange(event: any) {
    this.filterReportType = '2'
    // this.filterAdvisors = [];
    // this.isViewReport = false;
    // this.getBrokers(event)
    // if (this.filterReportType === '1') {
    //   this.getAdvisors();
    // } else if (this.filterReportType === '3') {
    //   this.getPartners();
    // }

    // changing table headers
    // this.tableHeaders = this.reportTypes.find(
    //   (el) => el.id === +this.filterReportType
    // ).tableHeaders;
    // this.actions = [...this.tableHeaders['Action']];

    // this.dtTrigger.unsubscribe();
    // this.dtTrigger = new Subject<any>();
  }
  onCustomerTypeChange(event: any) {
    var accessToken = sessionStorage.getItem('accessToken');
    var GetInvoiceData = `/api/ap/invoices/customers/${event.target.value}/${this.generateInvoiceform.get('paymentMethod')?.value}/list`;

    this.http.get(environment.apiUrl + GetInvoiceData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {

        console.log(res)
        this.finalCustomerRes = res.data
        this.invoiceNumber = res.invoiceNumber
        this.customerId = res.customerId
        this.fusbillCustomerIdDetails = res.fusebillCustomerId
        this.invoiceDate = this._CustomDatePipe.transform(res.invoiceDate)
        this.invoiceStatus = res.status
        this.dueDate = this._CustomDatePipe.transform(res.dueDate)
        this.invoiceAmount = adjustWith2DecimalsForUI(res.invoiceAmount)
        this.deleteInvoice = res.delete;
        this.regenerateInvoice = res.regenerate;
        this.cancelInvoice = res.cancel;
        this.refundInvoice = res.refund;


      },
      error: (error) => {
        console.log(error);
      },
    });

  }
  onBrokerTypeChange(event: any) {

  }
  onInvoiceTypeChange(event: any) {
    this.specialInvoiceTypeValue = ''
    // console.log(this.invoiceTypeValue)

  }

  clearInvoiceType() {

    this.invoiceTypeValue = ''
  }
  clearOverdueInvoiceType() {

    this.specialInvoiceTypeValue = ''
  }
  clearCustomerType() {
    this.customerTypeValue = ''

  }
  clearPaymentType() {
    this.paymentMethodValue = ''
  }


  onRangeChange() {

    // $('#DataTables_Table_1').dataTable().fnDestroy();
    //  this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.destroy();
    //   this.dtTrigger.next(null);
    // });

    this.filterDateSelection = '';
    this.filterAdvisors = [];
    this.paymentMethodValue = ''
    this.customerTypeValue = ''
    this.brokerTypeValue = ''
    this.invoiceTypeValue = ''
    this.filterReportType = ''
    this.customerid = ''
    this.fusbillCustomerId = ''
    // this.BrokersData = []
    this.viewInVoices = false;

    this.invoiceAmountDetails = false
    // $('#DataTables_Table_1').dataTable().fnDestroy();
    // this.dtTrigger.next(null);
  }
  onRangeChangeGenerate() {
    console.log(this.generateInvoiceform.get('filterIsMonthRangeGenerate')?.value)

    // console.log(this.filterIsMonthRangeGenerate)

  }
  onRangeChangeinvoiceGenerate() {

  }


  onItemSelect(item: any) {


    this.brokerid.push(item.id)

    // console.log(this.brokerid)
  }
  onSelectAll(items: any) {

    items.forEach((element: any) => {
      this.brokerid.push(element.id)
    })

    // console.log(this.brokerid)
  }
  onDeselectbroker(event: any) {
    let indexOf = this.brokerid.indexOf(event.id);
    this.brokerid.splice(indexOf, 1);
    // console.log(this.brokerid)
    // this.multiSelectProviancenames.splice(indexOf, 1);

  }
  onDeselectbrokerAll() {
    this.brokerid = []
    // console.log(this.brokerid)
  }
  ///
  onItemSelectCustomer(item: any) {


    this.customerDetails.push(item.fusebillCustomerId)


  }
  onSelectAllCustomer(items: any) {

    items.forEach((element: any) => {
      this.customerDetails.push(element.fusebillCustomerId)
    })

    // console.log(this.brokerid)
  }
  onDeselectbrokerCustomer(event: any) {
    let indexOf = this.customerDetails.indexOf(event.fusebillCustomerId);
    this.customerDetails.splice(indexOf, 1);
    // console.log(this.brokerid)
    // this.multiSelectProviancenames.splice(indexOf, 1);

  }
  onDeselectbrokerAllCustomer() {
    this.customerDetails = []
    // console.log(this.brokerid)
  }
  ////
  onItemSelectProvince(item: any) {

    // console.log(item)
    this.provinceNames.push(item.id)


  }
  onSelectAllProvince(items: any) {

    items.forEach((element: any) => {
      this.provinceNames.push(element.id)
    })

    // console.log(this.brokerid)
  }
  onDeselectbrokerProvince(event: any) {
    let indexOf = this.provinceNames.indexOf(event.id);
    this.provinceNames.splice(indexOf, 1);

    // console.log(this.brokerid)
    // this.multiSelectProviancenames.splice(indexOf, 1);

  }
  onDeselectbrokerAllProvince() {
    this.provinceNames = []

    // console.log(this.brokerid)
  }


  onItemSelectGenerate(item: any) {

    // console.log(item)
    this.generateInvoiceIds.push(item.brokerId)


  }
  onSelectAllGenerate(items: any) {

    items.forEach((element: any) => {
      this.generateInvoiceIds.push(element.brokerId)
    })

    // console.log(this.brokerid)
  }
  onDeselectbrokerGenerate(event: any) {
    let indexOf = this.generateInvoiceIds.indexOf(event.brokerId);
    this.generateInvoiceIds.splice(indexOf, 1);

    // console.log(this.brokerid)
    // this.multiSelectProviancenames.splice(indexOf, 1);

  }
  onDeselectbrokerAllGenerate() {
    this.generateInvoiceIds = []

    // console.log(this.brokerid)
  }

  onItemSelectSkipGenerate(item: any) {


    this.skipgenerateInvoiceIds.push(item.brokerId)


  }
  onSelectAllSkipGenerate(items: any) {

    items.forEach((element: any) => {
      this.skipMailgenerateInvoiceIds.push(element.brokerId)
    })

    // console.log(this.brokerid)
  }
  onDeselectbrokerSkipGenerate(event: any) {
    let indexOf = this.skipMailgenerateInvoiceIds.indexOf(event.brokerId);
    this.skipMailgenerateInvoiceIds.splice(indexOf, 1);

    // console.log(this.brokerid)
    // this.multiSelectProviancenames.splice(indexOf, 1);

  }
  onDeselectbrokerAllSkipGenerate() {
    this.skipMailgenerateInvoiceIds = []

    // console.log(this.brokerid)
  }

  //
  onItemSelectSkipMail(item: any) {


    this.skipMailgenerateInvoiceIds.push(item.brokerId)


  }
  onSelectAllSkipMail(items: any) {

    items.forEach((element: any) => {
      this.skipgenerateInvoiceIds.push(element.brokerId)
    })

    // console.log(this.brokerid)
  }
  onDeselectbrokerSkipMail(event: any) {
    let indexOf = this.skipgenerateInvoiceIds.indexOf(event.brokerId);
    this.skipgenerateInvoiceIds.splice(indexOf, 1);

    // console.log(this.brokerid)
    // this.multiSelectProviancenames.splice(indexOf, 1);

  }
  onDeselectbrokerAllSkipMail() {
    this.skipgenerateInvoiceIds = []

    // console.log(this.brokerid)
  }

  onItemSelectInvoice(item: any) {


    this.invoiceValue.push(item.value)

  }
  onSelectAllInvoice(items: any) {

    items.forEach((element: any) => {
      this.invoiceValue.push(element.value)
    })

  }
  onDeselectInvoice(event: any) {
    let indexOf = this.invoiceValue.indexOf(event.value);
    this.invoiceValue.splice(indexOf, 1);


  }
  onDeselectInvoiceAll() {
    this.invoiceValue = []
  }
  onItemSelectSpecialInvoice(item: any) {


    this.SpecialinvoiceValue.push(item.value)

  }
  onSelectAllSpecialInvoice(items: any) {

    items.forEach((element: any) => {
      this.SpecialinvoiceValue.push(element.value)
    })

  }
  onDeselectSpecialInvoice(event: any) {
    let indexOf = this.SpecialinvoiceValue.indexOf(event.value);
    this.SpecialinvoiceValue.splice(indexOf, 1);


  }
  onDeselectSpecialInvoiceAll() {
    this.SpecialinvoiceValue = []
  }

  onItemSelectCustomerType(item: any) {
    this.customerTypeValue1.push(item.value)
  }
  onSelectAllCustomerType(items: any) {
    items.forEach((element: any) => {
      this.customerTypeValue1.push(element.value)
    })
  }
  onDeselectCustomerType(event: any) {
    let indexOf = this.customerTypeValue1.indexOf(event.value);
    this.customerTypeValue1.splice(indexOf, 1);
  }
  onDeselectCustomerTypeAll() {
    this.customerTypeValue1 = []
  }

  // public skipDropdownData() {
  //   return this.finalCustomerRes.filter(
  //     (item) => !this.generateInvoiceIds.some((gen) => gen.brokerId === item.brokerId)
  //   );
  // }
  // get dropdown datas


  getBrokers() {

    // return false

    var accessToken = sessionStorage.getItem('accessToken');

    var GetBrokerData = `/api/ap/invoices/entity/ADVISOR/list`;


    this.http.get(environment.apiUrl + GetBrokerData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      },
    })
      .subscribe({
        next: (res: any) => {
          this.BrokersData = res.data.sort(
            (a: any, b: any) => (a.name > b.name ? 1 : -1)
          );
        },
        error: (error) => {
          console.log(error);
        },
      });
  }
  getCustomerTypeDetails(event: any) {
    var accessToken = sessionStorage.getItem('accessToken');
    var GetInvoiceData = `/api/ap/invoices/customers/${event.target.value}/list`;

    this.http.get(environment.apiUrl + GetInvoiceData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {

        this.customerTypeRes = res.data
        this.customerTypeRes = this.customerTypeRes.map(item => ({
          ...item,
          displayText: `${item.name}-${item.fusebillCustomerId}-${item.status}`,
        }));
        this.onSearch({event:{target:{value:''}}});

      },
      error: (error) => {
        console.log(error);
      },
    });

  }



  closePopup() {
    $('#DataTables_Table_2').dataTable().fnDestroy();
  }

  // future reports




  getReportTypeName(id: number) {
    const item = this.reportTypes.find((el) => el.id === id);
    return item?.reportType;
  }

  getPartnerName(id: number) {
    const item = this.advisors.find((el) => el.id === id);
    return item?.name;
  }

  // Payment
  showPayment(item) {
    this.paymentMonth = item.date;
    if (item.paymentDate) {
      this.paymentDate = new Date(item.paymentDate);
    } else {
      this.paymentDate = new Date();
    }
    this.paymentAmountPaid = item.amountPaid;
    $('#payment-modal').modal('show');
  }

  generateinvoice() {
    console.log(this.generateInvoiceform.value);
    var accessToken = sessionStorage.getItem('accessToken');
    // ${ this.generateInvoiceform.get('paymentMethod')?.value }mailToCustomer

    var generateInvoiceData = `/api/ap/invoices/customer/multiple/generateInvoiceIGBMS/${this.generateInvoiceform.get('invoiceMonth')?.value}/${this.generateInvoiceform.get('invoiceStatus')?.value}/${this.generateInvoiceform.get('mailToCustomer')?.value}/${this.generateInvoiceform.get('paymentMethod')?.value}`;

    if (this.generateInvoiceform.invalid) {
      console.log(this.generateInvoiceform.value);
      const invalid: any = [];
      const controls: any = this.generateInvoiceform.controls;

      for (let name in controls) {
        if (controls[name].invalid) {
          invalid.push(name)
        }
      }

      console.log(invalid)
      return;
    }


    let obj: any =
    {
      "ids": this.generateInvoiceIds,  // ---? list of customer ids to generate invoice for --> get from customer selection --> if all, then empty array
      "skipIds": this.skipgenerateInvoiceIds,  // ---? list of customer ids to skip the invoice generation--> get from customer selection --> if nothing to skip, then empty array
      "skipMails": this.skipMailgenerateInvoiceIds // ---? list of customer ids to generate the invoice but not trigger any mail--> get from customer selection --> if no customer to skip mail, then empty array
    }

    console.log(obj)

    this.http.post(environment.apiUrl + generateInvoiceData, obj, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {
        $("#generateInvoice-modal").modal('hide');

      },
      error: (error) => {
        console.log(error);
      },
    });



  }
  paymentcheck(event: any) {
    console.log(this.refundInvoiceFormPayment.value.paymentMethod)
    if (this.refundInvoiceFormPayment.value.paymentMethod == 'Other') {
      this.otherpaymentMethodValue = true
      this.refundInvoiceFormPayment.get('OtherpaymentMethod')?.setValidators([Validators.required]);
      this.refundInvoiceFormPayment.get('OtherpaymentMethod')?.updateValueAndValidity();
    }
    else {
      this.otherpaymentMethodValue = false
      this.refundInvoiceFormPayment.get('OtherpaymentMethod')?.reset()
      this.refundInvoiceFormPayment.get('OtherpaymentMethod')?.clearValidators()
      this.refundInvoiceFormPayment.get('OtherpaymentMethod')?.updateValueAndValidity();
    }



  }



  refundCancelinvoiceAmount() {

    var accessToken = sessionStorage.getItem('accessToken');
    var CancelInvoiceData = `/api/ap/invoices/no/${this.getInvoiceDetails.invoiceNumber}/cancel`;



    Swal.fire({
      title: 'Are you sure you want to cancel this invoice?',
      input: 'textarea', // Use 'textarea' for multiline input
      inputPlaceholder: 'Please type reason',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',

      inputValidator: (value) => {
        if (!value || value.trim() === '') {
          return 'You need to enter the reason!';
        }
        this.invoiceReason = value
        return null; // Return null if input is valid
      },
    }).then((result) => {
      if (result.isConfirmed) {
        let obj = {
          refund: this.refundCancelInvoiceForm.value.refundStatus,
          reason: this.invoiceReason,
          invoiceNumber: this.getInvoiceDetails.invoiceNumber
        }
        this.http.post(environment.apiUrl + CancelInvoiceData, obj, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe({
          next: (res: any) => {
            $('#refundcancel-modal').modal('hide');
            // Swal.fire({ title: "Info", text: res.message });
            this.applyFilters()
            // if (res.status == 200) {
            //   $('#editInvoice-modal').modal('hide');
            //   Swal.fire({ title: "Info", text: res.message });


            // }
          },
          error: (error) => {
            console.log(error);
          },
        });
      }
    })


  }
  planInformation(): FormArray {
    return this.refundInvoiceForm.get('plans') as FormArray;
  }
  removeRow(index: any) {
    console.log(index)
    const refundInvoiceArray = this.refundInvoiceForm as FormArray; // Ensure it's a FormArray
    if (refundInvoiceArray.length > index) { // Check if the index is valid
      refundInvoiceArray.removeAt(index); // Remove the FormGroup at the specified index
    }

  }

  onCheckboxChange(item: any, index: number, event: any): void {


    item.selected = event.target.checked;

    if (item.selected) {
      // Add item to the selectedItems array
      this.selectedItems.push({ ...item });
      this.isCheckboxDisabledTotal(item)
      this.isCheckboxDisabledPartial(item)
    } else {
      // Remove item from the selectedItems array
      const index = this.selectedItems.find(i => i.planName === item.planName && i.firstName === item.firstName && i.lastName === item.lastName);

      if (index !== -1) {
        this.selectedItems.splice(index, 1);
        this.isCheckboxDisabledTotal(item)
        this.isCheckboxDisabledPartial(item)
        item.refundType = null
      }
    }

    console.log('Selected items:', this.selectedItems);
    console.log(this.planInformation())
    console.log(index)
    console.log(item)

    // const isChecked = rowGroup.get('selected')?.value;
    console.log(event.target.checked)
    // Enable or disable the radio buttons and inputs based on checkbox
    if (event.target.checked) {

      const rowGroup = this.refundInvoiceForm.at(index);
      console.log(rowGroup)
      rowGroup.get('refundType')?.setValidators([Validators.required]);
      rowGroup.get('refundAmount')?.setValidators([Validators.required]);
      rowGroup.get('tax')?.setValidators([Validators.required]);
      rowGroup.get('refundAmountTotal')?.setValidators([Validators.required]);
      rowGroup.get('refundType')?.updateValueAndValidity();
      rowGroup.get('refundAmount')?.updateValueAndValidity();
      rowGroup.get('tax')?.updateValueAndValidity();
      rowGroup.get('refundAmountTotal')?.updateValueAndValidity();
    } else {

      const rowGroup = this.refundInvoiceForm.at(index);
      // const rowGroup = this.planInformation().at(index) as FormGroup;
      console.log(rowGroup)
      rowGroup.get('refundType')?.clearValidators();
      rowGroup.get('refundAmount')?.clearValidators();
      rowGroup.get('tax')?.clearValidators();
      rowGroup.get('refundAmountTotal')?.clearValidators();
      rowGroup.get('refundType')?.updateValueAndValidity();
      rowGroup.get('refundAmount')?.updateValueAndValidity();
      rowGroup.get('tax')?.updateValueAndValidity();
      rowGroup.get('refundAmountTotal')?.updateValueAndValidity();
      rowGroup.reset()
    }

    // Revalidate the form control after changing the validators

  }
  onCheckboxChange1(item: any, index: number, event: any): void {

    console.log(this.refundInvoiceForm)
    item.selected = event.target.checked;

    if (item.selected) {
      // Add item to the selectedItems array
      this.selectedItems.push({ ...item });
      // this.isCheckboxDisabledTotal(item)
    } else {
      // Remove item from the selectedItems array
      // const index = this.selectedItems.findIndex(i => i.planName === item.planName);

      const index = this.selectedItems.find(i => i.planName === item.planName && i.firstName === item.firstName && i.lastName === item.lastName)
      if (index !== -1) {
        this.selectedItems.splice(index, 1);
        // this.isCheckboxDisabledTotal(item)
        item.refundType = null
      }
    }

    console.log('Selected items:', this.selectedItems);
    // console.log(index)
    // console.log(item)

    // const isChecked = rowGroup.get('selected')?.value;
    console.log(event.target.checked)
    // Enable or disable the radio buttons and inputs based on checkbox
    if (event.target.checked) {

      const rowGroup = this.refundInvoiceForm.at(index);
      console.log(rowGroup)
      rowGroup.get('refundType')?.setValidators([Validators.required]);
      rowGroup.get('refundAmount')?.setValidators([Validators.required]);
      rowGroup.get('tax')?.setValidators([Validators.required]);
      rowGroup.get('refundAmountTotal')?.setValidators([Validators.required]);
      rowGroup.get('refundType')?.updateValueAndValidity();
      rowGroup.get('refundAmount')?.updateValueAndValidity();
      rowGroup.get('tax')?.updateValueAndValidity();
      rowGroup.get('refundAmountTotal')?.updateValueAndValidity();
    } else {

      const rowGroup = this.refundInvoiceForm.at(index);
      // const rowGroup = this.planInformation().at(index) as FormGroup;
      console.log(rowGroup)
      rowGroup.get('refundType')?.clearValidators();
      rowGroup.get('refundAmount')?.clearValidators();
      rowGroup.get('tax')?.clearValidators();
      rowGroup.get('refundAmountTotal')?.clearValidators();
      rowGroup.get('refundType')?.updateValueAndValidity();
      rowGroup.get('refundAmount')?.updateValueAndValidity();
      rowGroup.get('tax')?.updateValueAndValidity();
      rowGroup.get('refundAmountTotal')?.updateValueAndValidity();
      rowGroup.reset()
    }

    // Revalidate the form control after changing the validators

  }
  submiteditInvoice() {


    var GetInvoiceData = `/api/ap/invoices/${this.finalinvoiceres.id}/${this.finalinvoiceres.type}/status/${this.finalinvoiceres.status}/updateTo/${this.editInvoiceForm.value.invoicestatus}`
    var accessToken = sessionStorage.getItem('accessToken');
    var updateInvoiceData = `/api/ap/invoices/${this.invoiceviewDetails.id}`;
    this.http.get(environment.apiUrl + GetInvoiceData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe({
      next: (res: any) => {

        if (res.status == 200) {
          let obj: any = {
            "invoice": {
              "status": this.editInvoiceForm.value.invoicestatus,
              "invoiceAmount": +this.editInvoiceForm.value.invoiceAmount
            },
            "reason": this.editInvoiceForm.value.reason,
            "invoiceNumber": this.getInvoiceDetails.invoiceNumber
          }


          this.http.patch(environment.apiUrl + updateInvoiceData, obj, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            }
          }).subscribe({
            next: (res: any) => {
              $('#editInvoice-modal').modal('hide');
              this.applyFilters()

              if (res.status == 200) {

                Swal.fire({ title: "Info", text: res.message });

              }
            },
            error: (error) => {
              console.log(error);
            },
          });


        }
        else {
          Swal.fire({ title: "Info", text: res.message });
        }
        // $('#DataTables_Table_1').dataTable().fnDestroy();
        // this.dtTrigger.next(null);

        // this.inVoiceList = res.data
      },
      error: (error) => {
        console.log(error);
      },
    });



  }

  resetPayment() {
    this.paymentMonth = '';
    this.paymentDate = new Date();
    this.paymentAmountPaid = 0;
  }

  onSubmitAdjustment() {
    this.service.saveAdjustment(this.formAdjustment.value).subscribe({
      next: (res) => {
        $('#adjustment-modal').modal('hide');

        this.onResetAdjustment();
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  onResetAdjustment() {
    this.formAdjustment.reset();
  }

  onVoidAdjustment() {
    const data = this.formAdjustment.value;
    this.service
      .cancelAdjustment(data.reportTypeId, data.month, data.subId)
      .subscribe({
        next: (res) => {
          $('#adjustment-modal').modal('hide');
          this.onResetAdjustment();
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  onHistoryAdjustment() {
    $('#adjustment-history-modal').modal('show');
  }
  public capitalize(str: String) {
    if (str) {
      // return str.charAt(0).toUpperCase() + str.slice(1);
      const words = str.split(' ');

      let finalres: any = words.filter((v) => v != '');
      return finalres
        .map((word: any) => {
          return word[0].toUpperCase() + word.substring(1);
        })
        .join(' ');
    }
  }

  // sortInvoices(): void {
  //   if (this.isAmountAscending) {
  //     // Sort by invoiceAmount in ascending order
  //     this.inVoiceList.sort((a, b) => Number(a.invoiceAmount) - Number(b.invoiceAmount));
  //   } else {
  //     // Sort by invoiceAmount in descending order
  //     this.inVoiceList.sort((a, b) => Number(b.invoiceAmount) - Number(a.invoiceAmount));
  //   }

  //   // Toggle the sorting direction for the next click
  //   this.isAmountAscending = !this.isAmountAscending;
  //   console.log(this.inVoiceList.map((invoice:any)=>invoice.invoiceAmount))
  // }

  sortInvoices(column: string = ''): void {
    if (column === 'amount') {
      // Toggle sorting direction for the Amount column
      this.isAmountAscending = !this.isAmountAscending;
      this.sortAmount();
    }
  }

  // Sorting logic for Amount column
  sortAmount(): void {
    this.inVoiceList.sort((a, b) => {
      return this.isAmountAscending
        ? a.invoiceAmount - b.invoiceAmount  // Ascending sort
        : b.invoiceAmount - a.invoiceAmount; // Descending sort
    });
  }

}



